(function () {
  /* TD Draft 2026-09-26 D06 — removed debug log '[TD] custom.js v11 loaded' */
  /* TD Draft 2026-10-01 GATE — the quick-buy sheet contains a variant-picker since D02. Prestige preloads every unchecked
     option when a picker scrolls into view; in quick buy each preload is a full product page (set: 22 requests per opening).
     Skip only that intersection preload for variant-picker[context="quick_buy"]; hover, touch and change still fetch on demand.
     (Patching connectedCallback cannot work: the browser reads lifecycle callbacks once, at customElements.define in theme.js.) */
  (() => {
    if (!window.IntersectionObserver || IntersectionObserver.prototype.tdQbNoPreload) return;
    const observe = IntersectionObserver.prototype.observe;
    IntersectionObserver.prototype.observe = function (target) {
      if (target && target.localName === 'variant-picker' && target.getAttribute('context') === 'quick_buy') return undefined;
      return observe.apply(this, arguments);
    };
    IntersectionObserver.prototype.tdQbNoPreload = true;
  })();
  const escapeValue = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/"/g, '\\"');
  };

  const initDeliveryTime = () => {
    const containers = document.querySelectorAll('[data-td-delivery-time]');
    if (!containers.length) return;

    const getSelectedVariantId = (container) => {
      const form = container.closest('section')?.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');
      return form?.querySelector('input[name="id"]')?.value || null;
    };

    const showVariantBlock = (container, variantId) => {
      if (!variantId) return;
      const blocks = container.querySelectorAll('.td-delivery-time__item');
      blocks.forEach((block) => block.classList.add('is-hidden'));
      const active = container.querySelector(
        `.td-delivery-time__item[data-variant-id="${escapeValue(variantId)}"]`
      );
      if (active) active.classList.remove('is-hidden');
    };

    const refreshAll = () => {
      containers.forEach((container) => {
        const variantId = getSelectedVariantId(container);
        showVariantBlock(container, variantId);
      });
    };

    refreshAll();

    document.addEventListener('variant:change', refreshAll);
    document.addEventListener('product:variant-change', refreshAll);

    document.body.addEventListener('change', (event) => {
      if (event.target.matches('select[name^="options"], select[name^="SingleOptionSelector"], input[type="radio"][name^="options"]')) {
        requestAnimationFrame(refreshAll);
      }
    });

    document.body.addEventListener('click', (event) => {
      if (event.target.closest('[data-option], .product-form__input, .swatch, .variant-swatch, .product-option')) {
        setTimeout(refreshAll, 0);
      }
    });

    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && window.MutationObserver) {
      const observer = new MutationObserver(refreshAll);
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
  };

  const initTdVariantPicker = () => {
    const getContainers = () => document.querySelectorAll('[data-td-variant-picker]');

    const toggleByIdPrefix = (container, prefix, variantId) => {
      const items = container.querySelectorAll(`[id^="${prefix}_"]`);
      if (!items.length) return;

      items.forEach((item) => item.classList.add('hide'));
      if (!variantId) return;

      const target = container.querySelector(`#${prefix}_${escapeValue(variantId)}`);
      if (target) target.classList.remove('hide');
    };

    const toggleWeightOptvalFallback = (container, variantId) => {
      const optvalDivs = container.querySelectorAll('[data-td-weight-optval]');
      if (!optvalDivs.length) return;

      optvalDivs.forEach((d) => d.classList.add('hide'));

      if (variantId) {
        const variantDiv = container.querySelector(`#weight_info_${escapeValue(variantId)}`);
        if (variantDiv) return;
      }

      const fieldset = optvalDivs[0].closest('fieldset');
      if (!fieldset) return;

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const selectedVal = (checked.dataset.optionValue || '').trim();
      optvalDivs.forEach((d) => {
        if (d.dataset.tdWeightOptval === selectedVal) {
          d.classList.remove('hide');
        }
      });
    };

    const getSelectedOptions = (container, variant) => {
      if (variant && variant.id) {
        const selectedFromVariant = {};
        if (variant.option1) selectedFromVariant['1'] = variant.option1;
        if (variant.option2) selectedFromVariant['2'] = variant.option2;
        if (variant.option3) selectedFromVariant['3'] = variant.option3;
        return selectedFromVariant;
      }

      const selected = {};
      container.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
        const position = input.dataset.optionPosition;
        if (!position) return;

        let value = input.getAttribute('data-option-value');
        if (!value) {
          const label =
            container.querySelector(`label[for="${escapeValue(input.id)}"]`) ||
            input.closest('label');
          if (label) {
            const textNode = label.querySelector('span:not(.block-swatch__color):not(.sr-only)') || label;
            value = textNode.textContent;
          }
        }

        if (value) selected[position] = value.trim();
      });
      return selected;
    };

    const getVariantIdFromContainer = (container) => {
      const formId = container.dataset.formId;
      if (!formId) return null;
      const form = document.forms[formId];
      return form?.querySelector('input[name="id"]')?.value || null;
    };

    const updateBadges = (container, selectedOptions, variantId) => {
      const badges = container.querySelectorAll('[data-td-badge]');
      if (!badges.length) return;

      badges.forEach((badge) => badge.classList.add('td-variant-badge--hidden'));
      if (!variantId) return;

      const option1 = selectedOptions?.['1'];
      const option2 = selectedOptions?.['2'];
      if (!option1 && !option2) return;

      badges.forEach((badge) => {
        if (badge.dataset.variantOption1 === option1 && badge.dataset.variantOption2 === option2) {
          badge.classList.remove('td-variant-badge--hidden');
        }
      });
    };

    const updateSelectedValueLabels = (container, selectedOptions, variantId) => {
      if (!variantId) return;
      const cardFieldsets = container.querySelectorAll('[data-td-card-swatch="true"]');
      if (!cardFieldsets.length) return;

      cardFieldsets.forEach((fieldset) => {
        const optionPosition = fieldset.dataset.tdOptionPosition;
        if (!optionPosition) return;

        const text = selectedOptions?.[optionPosition];
        if (!text) return;

        const target = fieldset.querySelector('[data-td-option-selected-value]');
        if (target) target.textContent = text;
      });
    };

    /* ---------------------------------------------------------
       Hide unavailable option values
       ---------------------------------------------------------
       Uses inline styles on wrapper elements to show/hide option
       values based on cascading availability.
       Called from variant:change, product:rerender, and direct
       change/click listeners to keep the filter in sync.
       --------------------------------------------------------- */
    const applyUnavailableFilter = (container, variant) => {
      if (!container.hasAttribute('data-hide-unavailable')) return;
      /* TD 2026-10-02 PILLOW-PDP — a td_only_orderable picker moving to its orderable target (applyOrderableTarget):
         its server-rendered values already follow the target. After a failed move (data-td-oo-failed) the values
         follow the form's variant again, but no radio is checked by hand (see applyOrderableTarget). */
      if (container.hasAttribute('data-td-oo-pending')) return;
      const tdOoFailed = container.hasAttribute('data-td-oo-failed');
      // TD Draft 2026-09-28 G2-P01 — pickers with explain_unavailable: nearest weight + 'what changed' line, sold-out sizes stay visible (assets/td-draft-0928-p01.js)
      if (window.tdP01 && window.tdP01.filter(container, variant)) return;

      const script = container.querySelector('script[data-td-variants-availability]');
      if (!script) return;

      let allVariants;
      try { allVariants = JSON.parse(script.textContent); } catch (e) { return; }
      /* TD Draft 2026-09-26 D09 — fully sold-out product: filter nothing, so every size/filling stays visible
         (crossed out) and 'Benachrichtigen' still works for each variant, as on live */
      if (!allVariants.some((v) => v.a)) return;

      const optionCount = allVariants.reduce((max, v) => {
        let c = 0;
        if (v.o1 != null) c = 1;
        if (v.o2 != null) c = 2;
        if (v.o3 != null) c = 3;
        return Math.max(max, c);
      }, 0);

      /* Read selected values from variant object (authoritative)
         or fall back to DOM on initial load */
      const selected = {};
      if (variant && variant.id) {
        if (variant.option1) selected[1] = variant.option1;
        if (variant.option2) selected[2] = variant.option2;
        if (variant.option3) selected[3] = variant.option3;
      } else {
        for (let pos = 1; pos <= optionCount; pos++) {
          const checked = container.querySelector(`input[data-option-position="${pos}"]:checked`);
          if (checked) {
            selected[pos] = checked.dataset.optionValue || '';
          }
        }
      }

      const autoSelected = new Set();

      for (let pos = 1; pos <= optionCount; pos++) {
        /* For each option: find values that can produce an available variant
           given the options ABOVE it (cascade top-down).
           Option 1 → show all, Option 2 → filter by option 1,
           Option 3 → filter by options 1+2 */
        const availableValues = new Set();
        for (const v of allVariants) {
          if (!v.a) continue;
          let matches = true;
          for (let other = 1; other < pos; other++) {
            if (selected[other] && v[`o${other}`] !== selected[other]) {
              matches = false;
              break;
            }
          }
          if (matches) availableValues.add(v[`o${pos}`]);
        }

        /* Auto-select first available value (in DOM order) when the
           current selection is unavailable — keeps the cascade valid */
        const wrappers = container.querySelectorAll(`[data-option-pos="${pos}"]`);
        if (!tdOoFailed && selected[pos] && !availableValues.has(selected[pos]) && availableValues.size > 0) {
          for (const wrapper of wrappers) {
            const val = wrapper.dataset.optionVal;
            if (val && availableValues.has(val)) {
              selected[pos] = val;
              autoSelected.add(pos);
              break;
            }
          }
        }

        /* Show/hide wrapper elements via inline style */
        wrappers.forEach((wrapper) => {
          const val = wrapper.dataset.optionVal;
          if (!val) return;
          if (availableValues.has(val) || val === selected[pos]) {
            wrapper.style.removeProperty('display');
          } else {
            wrapper.style.setProperty('display', 'none', 'important');
          }
        });

        /* TD Draft 2026-09-26 D06 — option groups with only one selectable value collapse to
           'Legend: value' (radio stays checked in the form). Replaces the '[TD filter]' debug log. */
        const tdFieldset = container.querySelector(`fieldset[data-td-option-position="${pos}"]`);
        if (tdFieldset && wrappers.length) {
          const visible = [...wrappers].filter((w) => w.style.display !== 'none');
          /* TD Draft 2026-09-28 D06-SINGLE-OFF — Felix 28.09.2026 „show all swatches even when only one option available - like it was before“:
             no collapse to 'Legend: value' any more; a group with one selectable value keeps its card(s) as on live. */
          const isSingle = false && visible.length === 1;
          /* TD Draft 2026-09-28 D06-SINGLE-OFF — a lone visible card keeps its card width on phones instead of stretching
             over the row (assets/td-draft-0928-g1-d06-q14.css .td-option--lone) */
          tdFieldset.classList.toggle('td-option--lone', visible.length === 1);
          tdFieldset.classList.toggle('td-option--single', isSingle);
          let label = tdFieldset.querySelector('[data-td-single-value]');
          const legend = tdFieldset.querySelector('legend');
          /* swatch-style options already print the value in a plain span after the legend */
          const next = legend ? legend.nextElementSibling : null;
          const hasValueSpan = !!next && next.tagName === 'SPAN' && next !== label;
          if (isSingle && !hasValueSpan && !tdFieldset.querySelector('[data-td-option-selected-value]')) {
            if (!label) {
              label = document.createElement('span');
              label.className = 'td-variant-picker__single-value';
              label.setAttribute('data-td-single-value', '');
              if (legend) legend.after(label);
            }
            label.textContent = visible[0].dataset.optionVal || '';
          } else if (!isSingle && label) {
            label.remove();
          }
        }
      }

      /* Check radios for auto-selected values and trigger Prestige
         to resolve the correct variant */
      if (autoSelected.size > 0) {
        let lastChanged = null;
        for (const pos of autoSelected) {
          const inputs = container.querySelectorAll(`input[data-option-position="${pos}"]`);
          for (const input of inputs) {
            if (input.dataset.optionValue === selected[pos] && !input.checked) {
              input.checked = true;
              lastChanged = input;
            }
          }
        }
        if (lastChanged) {
          lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    };

    const updateContainer = (container, variant) => {
      const variantId = variant?.id || getVariantIdFromContainer(container);
      const selectedOptions = getSelectedOptions(container, variant);

      toggleByIdPrefix(container, 'weight_info', variantId);
      toggleWeightOptvalFallback(container, variantId);
      toggleByIdPrefix(container, 'second_weight_info', variantId);
      toggleByIdPrefix(container, 'cover_type_info', variantId);

      updateBadges(container, selectedOptions, variantId);
      updateSelectedValueLabels(container, selectedOptions, variantId);
    };

    const updateAll = () => {
      getContainers().forEach((container) => {
        updateContainer(container, null);
      });
    };

    updateAll();

    const refreshFilter = () => {
      getContainers().forEach((container) => {
        applyUnavailableFilter(container, null);
      });
    };

    /* Initial filter */
    refreshFilter();

    /* TD 2026-10-02 PILLOW-PDP — td_only_orderable: a page opened on a variant that cannot be ordered (?variant= of an old
       ad, Shopping or e-mail link) moves to the closest orderable variant. snippets/td-variant-picker.liquid renders the
       values that go with that target, hands over its option value ids (data-td-oo-values) and sets data-td-oo-pending,
       which hides the old value's card, the price and the buttons (assets/custom.css).
       The move asks Shopify for the target like a tap does (?option_values=…&section_id=…) and then does what the
       picker's selectCombination does with the answer — form id, address, product:rerender, variant:change — so radios,
       price, buttons and form change together and the page never shows one variant and adds another (no radio is
       checked by hand). It is its own request because theme.js keeps every answer of selectCombination for the page,
       a failed one too: a failed move would break the buyer's later tap on the same combination.
       If the answer fails, holds no orderable variant or takes longer than 10 s, data-td-oo-failed replaces
       data-td-oo-pending: the page shows the variant the form holds ('Ausverkauft', nothing can be added) and the
       sold-out filter does not check other radios by hand (applyUnavailableFilter); a tap on a value asks Shopify as usual.
       (The 02.10. switch for pages without ?variant= is gone: it opened the 7 valentine pillows on their new 40 x 60 cm
       variants, whose compare-at price of 34,00€ was never charged.) */
    const applyOrderableTarget = (container) => {
      const raw = container.getAttribute('data-td-oo-values');
      if (!raw || container.dataset.tdOoDone === 'true') return;
      container.dataset.tdOoDone = 'true';
      let settled = false;
      const release = () => {
        if (settled) return;
        settled = true;
        container.setAttribute('data-td-oo-failed', '');
        container.removeAttribute('data-td-oo-pending');
        refreshFilter();
      };
      let values = null;
      try {
        values = JSON.parse(raw);
      } catch (error) {
        values = null;
      }
      const formId = container.getAttribute('form-id');
      const form = formId ? document.forms[formId] : null;
      const sectionId = container.getAttribute('section-id');
      const handle = container.getAttribute('handle');
      if (!Array.isArray(values) || !values.length || !form || !sectionId || !handle) {
        release();
        return;
      }
      window.setTimeout(release, 10000);
      /* TD Draft 2026-10-05 FIX-0510 (Codex round 3, P2): the buyer picks a value before the answer is in → the buyer's
         choice wins: the move is dropped like a failed one (the theme asks Shopify for the picked value as usual) and
         the late answer changes nothing. Only the buyer's own change counts (isTrusted), not the radios this file or
         the theme check by script. */
      container.addEventListener('change', (event) => {
        if (event.isTrusted) release();
      }, true);
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}products/${encodeURIComponent(handle)}?option_values=${values.map(Number).join(',')}&section_id=${encodeURIComponent(sectionId)}`, { cache: 'no-store' })
        .then((response) => (response.ok ? response.text() : Promise.reject(new Error(`status ${response.status}`))))
        .then((text) => {
          /* too late: the buyer has chosen meanwhile, or the picker was re-rendered (FIX-0510: a disconnected picker's
             answer changes nothing either) */
          if (settled || !container.isConnected) return;
          const fragment = document.createRange().createContextualFragment(text);
          const picker = fragment.querySelector(`variant-picker[form-id="${formId}"]`);
          const data = picker ? picker.querySelector('script[data-variant]') : null;
          const variant = data ? JSON.parse(data.textContent || '{}') : null;
          if (!variant || !variant.id || variant.available === false) throw new Error('no orderable variant in the answer');
          settled = true;
          let previousVariant = null;
          try {
            previousVariant = JSON.parse(container.querySelector('script[data-variant]')?.textContent || 'null');
          } catch (error) {
            previousVariant = null;
          }
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = variant.id;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (container.hasAttribute('update-url')) {
            const address = new URL(window.location.href);
            address.searchParams.set('variant', variant.id);
            window.history.replaceState({ path: address.toString() }, '', address.toString());
          }
          form.dispatchEvent(new CustomEvent('product:rerender', { detail: { htmlFragment: fragment, productChange: false } }));
          form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { formId: idInput, variant, previousVariant } }));
          if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') window.Shopify.PaymentButton.init();
        })
        .catch(release);
    };
    getContainers().forEach(applyOrderableTarget);

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      /* Prestige dispatches on the form. event.detail.formId may be the
         <input name="id"> element (form.id shadowed by named control).
         Use event.target.getAttribute('id') for a reliable string. */
      const eventFormId = event.target?.getAttribute?.('id') || null;

      getContainers().forEach((container) => {
        if (eventFormId && container.dataset.formId && container.dataset.formId !== eventFormId) return;
        updateContainer(container, variant || null);
        applyUnavailableFilter(container, variant || null);
      });
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('form[action*="/cart/add"] input[name="id"]')) {
        updateAll();
      }
    });

    /* product:rerender does NOT bubble (Prestige dispatches with
       default bubbles:false on the form), so listen on each form directly */
    getContainers().forEach((container) => {
      const rerenderFormId = container.dataset.formId;
      if (!rerenderFormId) return;
      const rerenderForm = document.getElementById(rerenderFormId) || document.forms[rerenderFormId];
      if (!rerenderForm) return;
      rerenderForm.addEventListener('product:rerender', () => {
        getContainers().forEach((c) => {
          updateContainer(c, null);
          applyUnavailableFilter(c, null);
        });
      });
    });

    /* Direct radio/click listeners — catches option changes even if
       Prestige custom events (variant:change, product:rerender) don't fire */
    document.body.addEventListener('change', (event) => {
      if (event.target.matches('[data-td-variant-picker] input[type="radio"]') ||
          event.target.matches('[data-td-variant-picker] select')) {
        requestAnimationFrame(refreshFilter);
      }
    });

    document.body.addEventListener('click', (event) => {
      if (event.target.closest('[data-td-variant-picker] label') ||
          event.target.closest('[data-td-variant-picker] .block-swatch') ||
          event.target.closest('[data-td-variant-picker] .color-swatch') ||
          event.target.closest('[data-td-variant-picker] .td-variant-picker__value')) {
        requestAnimationFrame(() => requestAnimationFrame(refreshFilter));
      }
    });

    /* MutationObserver on variant ID input — catches changes from any source */
    getContainers().forEach((container) => {
      const formId = container.dataset.formId;
      if (!formId) return;
      const form = document.forms[formId];
      const idInput = form?.querySelector('input[name="id"]');
      if (idInput && window.MutationObserver) {
        const observer = new MutationObserver(() => {
          requestAnimationFrame(refreshFilter);
        });
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    });

    /* TD Draft 2026-09-26 D02 — quick-buy sheet: apply sold-out filter + weight info as soon as the
       content is shown. QuickBuyModal inserts its content before show(), so before-show already sees
       the picker; after-show is the safety net. Dialog events do not bubble → capture phase. */
    const onQuickBuyShow = (event) => {
      const modal = event.target;
      if (!modal || !modal.matches || !modal.matches('quick-buy-modal')) return;
      modal.querySelectorAll('[data-td-variant-picker]').forEach((container) => {
        updateContainer(container, null);
        applyUnavailableFilter(container, null);
      });
    };
    document.addEventListener('dialog:before-show', onQuickBuyShow, true);
    document.addEventListener('dialog:after-show', onQuickBuyShow, true);

    /* TD Draft 2026-09-26 D02 — quick-buy option changes. <product-rerender id="quick-buy-modal-content">
       has no allow-partial-rerender, so every change swaps the whole sheet incl. the <form>: variant:change
       then fires on the detached form and never reaches document. (a) Fix an unavailable combination
       synchronously, before Prestige's body-delegated handler fetches it (quick buy fetches the full
       product page; the old rAF auto-select sent a second request that raced the next tap).
       (b) Keep add-to-cart off while the form still holds the old variant id.
       (c) Re-apply filter + weight info after each swap (product:rerender does not bubble; capture sees it). */
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input || !input.matches || !input.matches('quick-buy-modal [data-td-variant-picker] input[type="radio"]')) return;
      applyUnavailableFilter(input.closest('[data-td-variant-picker]'), null);
      const modal = input.closest('quick-buy-modal');
      const submit = modal.querySelector('form[action*="/cart/add"] button[type="submit"]');
      if (submit) { submit.disabled = true; submit.classList.add('td-qb-pending'); } /* the swapped-in sheet brings a fresh button */
      /* (d) remember the latest user selection (after the filter) so a late response for an earlier tap cannot revert it */
      modal.tdWanted = [...modal.querySelectorAll('[data-td-variant-picker] input[data-option-position]:checked')]
        .map((i) => [i.dataset.optionPosition, i.dataset.optionValue]);
    }, true);
    /* the one quick-buy-modal is reused for every product: forget the last product's selection on open */
    document.addEventListener('dialog:before-show', (event) => {
      if (event.target && event.target.matches && event.target.matches('quick-buy-modal')) event.target.tdWanted = null;
    }, true);
    document.addEventListener('product:rerender', (event) => {
      const modal = event.target && event.target.closest ? event.target.closest('quick-buy-modal') : null;
      if (!modal) return;
      /* product:rerender fires before <product-rerender> swaps the sheet; a microtask runs after the swap but
         before the next paint (setTimeout(0) let ~1 in 10 swaps paint one frame with an unavailable weight) */
      queueMicrotask(() => {
        onQuickBuyShow({ target: modal });
        /* (d) a response for an earlier tap can land after a later tap: re-select what the user last chose */
        const wanted = modal.tdWanted;
        if (!wanted) return;
        const inputs = [];
        for (const [pos, val] of wanted) {
          const inp = modal.querySelector(`[data-td-variant-picker] input[data-option-position="${pos}"][data-option-value="${CSS.escape(val)}"]`);
          if (!inp || inp.disabled) return;
          inputs.push(inp);
        }
        const changed = inputs.filter((i) => !i.checked);
        if (!changed.length) return;
        changed.forEach((i) => { i.checked = true; });
        changed[changed.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      });
    }, true);
  };

  const initTdCollectionProducts = () => {
    const getRoots = () => document.querySelectorAll('[data-td-collection-products]');

    const updateVisibility = () => {
      const isMobile = window.innerWidth < 700;

      getRoots().forEach((root) => {
        const desktopColumns = parseInt(root.dataset.desktopColumns || '4', 10);
        const desktopRows = parseInt(root.dataset.desktopRows || '1', 10);
        const mobileColumns = parseInt(root.dataset.mobileColumns || '2', 10);
        const mobileRows = parseInt(root.dataset.mobileRows || '2', 10);
        const maxVisible = isMobile ? mobileColumns * mobileRows : desktopColumns * desktopRows;
        const items = root.querySelectorAll('[data-td-collection-item]');

        items.forEach((item, index) => {
          item.hidden = index >= maxVisible;
        });
      });
    };

    const updateDynamicTitle = (root, link) => {
      if (!root || root.dataset.showDynamicTitle !== 'true') return;

      const valueNode = root.querySelector('[data-td-collection-value]');
      if (!valueNode) return;

      const productTitle = link?.dataset?.productTitle || root.dataset.defaultTitle || '';
      valueNode.textContent = productTitle;
    };

    /* TD: hover/focus selection removed — only the current product stays selected */

    updateVisibility();
    window.addEventListener('resize', updateVisibility);
    document.addEventListener('product:rerender', updateVisibility);
  };

  /* -----------------------------------------------
     TD Upsell Addon — toggle + variant resolution + cart
     TD 2026-10-02 PILLOW-PDP (Felix: pillows only as "Ohne (Nur Kissenbezug)" in 40 x 60 / 40 x 80 cm for now):
     - The lists come filtered from snippets/td-upsell-addon.liquid (only values of orderable variants). Here a value
       also stays selectable only while an orderable variant matches the values chosen above it, so the hidden
       variant id is always an orderable one.
     - Adding: with the switch on, the pillow goes into the SAME /cart/add.js request as the main product. The theme's
       product form builds its request with new FormData(form); the 'formdata' event moves id/quantity/properties to
       items[1][…] and puts the pillow first as items[0] (Shopify lists the last line on top, so the drawer shows the
       main product first; the Q13 'Hinzugefügt' row gets the main product first as well). One request, one drawer
       refresh with both lines. Only a submit of the form the block belongs to counts (quick buy and other forms on the
       page are left alone).
     - Exactly one pillow per add: a submit the theme ignores (its button is still aria-busy — Enter pressed twice, key
       held down) or that Q13 stops (td-q13-busy) is not counted, and a submit that built no request (invalid form,
       stopped by another listener) is dropped right after its dispatch. Each request is matched to its own answer
       (variant:add / cart:error, first in first out).
     - Shopify adds all lines or none: if the bundled request fails (e.g. the pillow sold out while the page was open),
       the main product is added alone, the switch goes off and the block says the pillow could not be added. If that
       fails as well, the theme's error shows as usual.
     - Browsers without the formdata event (Safari < 15) get the pillow in a second request after the theme's
       variant:add, handed over with the drawer section (cart:change needs cart.sections).
     - The document listeners are registered once and look up the block at event time, so a re-rendered block never
       adds a second pillow.
     TD Draft 2026-10-04 ADDON-MASK (Felix 04.10.2026: "Schlafmaske dazu −10%" on adult blankets, the vest on kids
     blankets) — several add-on switches per product form (the pillow block plus td_addon_switch blocks,
     snippets/td-addon-switch.liquid, same markup):
     - Every switched-on add-on of the form goes into the same request: items[0…n-1] = the add-ons in reverse page order,
       items[n] = the main product, so the drawer lists blanket, pillow, mask (top to bottom, the order on the page) and
       the 'Hinzugefügt' row counts all of them. Switching a switch off removes nothing that is already in the cart.
     - A block with data-td-addon-percent shows its DISPLAY discount: "<s>price</s> (+ price − percent)"; the cart does
       not apply it (no discount code is sent — the discount engine is still open). The thumbnail follows the chosen
       variant when the variants JSON has images.
     - If the bundled request fails, the add-ons that /products/<handle>.js still reports as orderable are tried again
       with the main product; if that fails too (or every add-on looks orderable, so the culprit is unknown), the main
       product goes in alone. Only the add-ons that did not go in are switched off and get their note. With a single
       add-on (the pillow alone) this is exactly the behaviour above.
     TD Draft 2026-10-04 ADDON-UI (Felix 04.10.2026: "the variant selectors for the upsells take a lot of space - that
     dropdown", "if upsell not available … just hide it"):
     - An option can be a radio group ([data-td-choice], snippets/td-addon-choice.liquid: colour dots or text chips)
       instead of a dropdown; its checked radio is the chosen value, values without an orderable variant for the values
       chosen before them are hidden, and [data-td-choice-current] shows the chosen colour's name.
     - No note any more: an add-on that did not go into the cart (sold out meanwhile, variant gone) is switched off and its
       whole block is hidden; it stays hidden until the next page load, also after a product re-render. The pillow now
       also shows a display-only discount when its block has data-td-addon-percent.
     TD 2026-10-13 SECOND15 (Felix 13.10.2026: 15% on a 2nd mask / collar) — an add-on box may carry hidden line
     properties (data-td-upsell-properties, keys starting with "_"): the second-unit box (snippets/td-addon-switch.liquid,
     mode 'same') sends {"_td_second":"1"}, so the second unit is its own cart line (never merged with the main unit or an
     existing line of the same variant). Boxes without the attribute are added exactly as before.
     ----------------------------------------------- */
  const initTdUpsellAddon = () => {
    const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* TD Draft 2026-10-03 ADDED-PILLOW — Felix: "No space before € or %" (shop money format since 03.10.2026
       '{{amount_with_comma_separator}}€'): the price after a size change reads 24,00€ like the Liquid one (was '24,00 €') */
    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + '€';
    };

    const escapeHtml = (text) => String(text || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const readVariants = (container) => {
      const scriptEl = container.nextElementSibling?.matches('script[data-td-upsell-variants-json]')
        ? container.nextElementSibling
        : container.parentElement?.querySelector('script[data-td-upsell-variants-json]');
      try {
        return scriptEl ? JSON.parse(scriptEl.textContent || '[]') : [];
      } catch (error) {
        return [];
      }
    };

    const orderable = (variant) => !!variant && variant.available !== false;

    /* TD Draft 2026-10-04 ADDON-MASK — displayed discount of a td_addon_switch block (0 = none); the reduced price is
       rounded like Shopify rounds a percentage discount (snippets/td-addon-switch.liquid does the same) */
    const discountPercent = (container) => {
      const n = parseInt(container.dataset.tdAddonPercent || '0', 10);
      return n > 0 && n < 100 ? n : 0;
    };
    const reducedPrice = (cents, percent) => cents - Math.floor((cents * percent + 50) / 100);

    /* TD Draft 2026-10-04 ADDON-UI — an option is a <select>, a hidden input (one fixed value) or a radio group of
       colour dots / text chips ([data-td-choice]) */
    const isChoice = (control) => control.hasAttribute('data-td-choice');
    const radiosOf = (control) => Array.from(control.querySelectorAll('input[type="radio"]'));
    const valueOf = (control) => {
      if (!isChoice(control)) return control.value;
      const checked = radiosOf(control).find((radio) => radio.checked);
      return checked ? checked.value : '';
    };

    /* TD Draft 2026-10-04 ADDON-UI — add-ons that could not go into the cart stay hidden until the next page load:
       '<form id>|<add-on handle>' */
    const goneKeys = window.tdAddonGone || (window.tdAddonGone = new Set());
    const goneKey = (container) => `${container.dataset.tdUpsellFormId || ''}|${container.dataset.tdUpsellHandle || ''}`;

    /* TD 2026-10-07 ADDON-QTY (Felix 07.10.2026: "add a quantity option once the toggle has been turned on") — stepper
       [data-td-upsell-qty] in [data-td-addon-qty-row] (snippets/td-addon-qty.liquid), shown while the switch is on.
       Its max is the block's quantity_max (data-td-qty-max); a variant marked "one" in the variants JSON (tracked, policy
       deny: a larger quantity could be rejected) stays at 1 and the row is hidden. The input has no name / form: it is
       never the blanket's quantity. */
    const qtyInputOf = (container) => container.querySelector('[data-td-upsell-qty]');
    const qtyLimitOf = (container, variant) => {
      const input = qtyInputOf(container);
      if (!input) return 1;
      if (variant && variant.one === true) return 1;
      const limit = parseInt(input.dataset.tdQtyMax || input.max || '1', 10) || 1;
      return Math.max(1, limit);
    };
    const qtyOf = (container) => {
      const input = qtyInputOf(container);
      if (!input) return 1;
      const max = Math.max(1, parseInt(input.max || '1', 10) || 1);
      const value = parseInt(input.value, 10);
      return Math.min(max, Math.max(1, Number.isNaN(value) ? 1 : value));
    };
    /* sets the stepper (value, max, the theme's −/+ state) without leaving it out of range */
    const setQty = (container, value, variant) => {
      const input = qtyInputOf(container);
      if (!input) return;
      if (variant !== undefined) input.max = String(qtyLimitOf(container, variant));
      const max = Math.max(1, parseInt(input.max || '1', 10) || 1);
      const next = Math.min(max, Math.max(1, parseInt(value, 10) || 1));
      if (String(next) !== input.value) input.value = String(next);
      const selector = input.closest('quantity-selector');
      const buttons = selector ? selector.querySelectorAll('button') : [];
      if (buttons.length === 2) {
        buttons[0].disabled = next <= 1;
        buttons[1].disabled = next >= max;
      }
      const wrapper = input.parentElement;
      if (wrapper) wrapper.style.setProperty('--quantity-selector-character-count', `${Math.max(1, input.value.length)}ch`);
    };
    const resetQty = (container) => {
      const row = container.querySelector('[data-td-addon-qty-row]');
      if (row) row.hidden = true;
      setQty(container, 1);
    };
    const hideAddon = (container) => {
      if (!container) return;
      const toggle = container.querySelector('[data-td-upsell-toggle]');
      const optionsArea = container.querySelector('[data-td-upsell-options]');
      if (toggle) toggle.checked = false;
      if (optionsArea) optionsArea.hidden = true;
      /* TD 2026-10-07 ADDON-QTY — the quantity row goes back to 1 and hides with the card */
      resetQty(container);
      container.hidden = true;
      /* the theme's block wrapper too, so no empty gap is left between the blocks — TD 2026-10-23 INLET-SET (Codex R1):
         only when no other offer in that block is still usable. The covers' "Zweiten Bezug dazu" block also holds the
         inlet boxes (snippets/td-inlet-set.liquid): one of them failing must not hide the others. */
      const item = container.closest('.product-info__block-item');
      const usable = item ? Array.from(item.querySelectorAll('[data-td-upsell-addon]')).filter((el) => el !== container && !isGone(el)) : [];
      if (item && !usable.length) item.hidden = true;
      if (container.dataset.tdUpsellHandle) goneKeys.add(goneKey(container));
    };
    const isGone = (container) => container.hidden || goneKeys.has(goneKey(container));

    const setupContainer = (container) => {
      if (container.dataset.tdUpsellReady === 'true') return;
      container.dataset.tdUpsellReady = 'true';

      const toggle = container.querySelector('[data-td-upsell-toggle]');
      const optionsArea = container.querySelector('[data-td-upsell-options]');
      const variantInput = container.querySelector('[data-td-upsell-variant-id]');
      const priceEl = container.querySelector('[data-td-upsell-price]');
      const controls = Array.from(container.querySelectorAll('[data-td-upsell-option]'));
      const variantsJson = readVariants(container);

      const qtyRow = container.querySelector('[data-td-addon-qty-row]');
      const qtyInput = qtyInputOf(container);
      const currentVariant = () => variantsJson.find((v) => variantInput && String(v.id) === variantInput.value) || null;

      /* TD 2026-10-07 ADDON-QTY — the price of the chosen quantity. Felix 07.10.2026: "actually allow the discount of all
         pillow covers and masks - no limit": the discount app gives "Extra −X%" to every pillowcase / mask in a cart with
         a blanket (this add brings one), so N pieces = N × the price struck and N × the reduced price. */
      const qtyLive = container.querySelector('[data-td-addon-qty-live]');
      const paintPrice = (variant, announce) => {
        if (!priceEl || !variant) return;
        /* same reading as the Liquid markup: "Regulärer Preis 29,00€ (+ Angebot 24,00€)" */
        const regular = priceEl.dataset.labelRegular || '';
        const sale = priceEl.dataset.labelSale || '';
        const percent = discountPercent(container);
        const units = qtyInput ? qtyOf(container) : 1;
        /* TD Draft 2026-10-04 ADDON-MASK — displayed discount: the variant price struck, the reduced price in the brackets */
        const struck = (percent ? variant.price : (variant.compare_at_price || 0)) * units;
        const shown = (percent ? reducedPrice(variant.price, percent) : variant.price) * units;
        const onSale = percent ? true : !!(variant.compare_at_price && variant.compare_at_price > variant.price);
        const compareHtml = onSale
          ? '<s class="td-upsell-addon__compare-price" data-td-upsell-compare-price>'
            + (regular ? '<span class="sr-only">' + escapeHtml(regular) + ' </span>' : '')
            + formatMoney(struck) + '</s> '
          : '';
        const saleHtml = onSale && sale ? '<span class="sr-only">' + escapeHtml(sale) + ' </span>' : '';
        priceEl.innerHTML = compareHtml + '(+ ' + saleHtml + formatMoney(shown) + ')';
        /* screen readers hear the new price after a quantity change */
        if (announce && qtyLive) qtyLive.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
      };

      const syncOpen = () => {
        const on = !!(toggle && toggle.checked);
        if (optionsArea) optionsArea.hidden = !on;
        /* no stepper for a variant that stays at 1 */
        if (qtyRow) qtyRow.hidden = !on || qtyLimitOf(container, currentVariant()) <= 1;
      };

      if (toggle) {
        toggle.addEventListener('change', () => {
          syncOpen();
          /* TD 2026-10-07 ADDON-QTY — switched off: back to 1 piece (and its price) for the next time */
          if (!toggle.checked && qtyInput && qtyOf(container) !== 1) {
            setQty(container, 1);
            paintPrice(currentVariant());
          }
        });
      }

      if (qtyInput) {
        /* the whole value is selected on focus (also after a tap, where a plain select() does not stick), so a typed
           digit replaces it; a digit typed onto a value that is then above the max replaces it too ("3" into "2" →
           "23" → 3). Typing repaints with the value in range; leaving the field and the −/+ buttons (change event) put
           the field itself back into 1 … max. */
        qtyInput.addEventListener('focus', () => {
          window.requestAnimationFrame(() => {
            try { qtyInput.select(); } catch (error) { /* number inputs without selection support */ }
          });
        });
        qtyInput.addEventListener('input', (event) => {
          const max = Math.max(1, parseInt(qtyInput.max || '1', 10) || 1);
          const typed = event && typeof event.data === 'string' && /^[0-9]$/.test(event.data) ? parseInt(event.data, 10) : 0;
          if (typed >= 1 && typed <= max && (parseInt(qtyInput.value, 10) || 0) > max) qtyInput.value = String(typed);
          paintPrice(currentVariant(), true);
        });
        qtyInput.addEventListener('change', () => {
          setQty(container, qtyInput.value);
          paintPrice(currentVariant(), true);
        });
        setQty(container, qtyInput.value, currentVariant());
      }
      /* a switch the browser restored as "on" (back navigation) shows its options and quantity */
      syncOpen();

      /* each list keeps only values with an orderable variant for the values chosen above it */
      const chosenOptions = () => {
        const chosen = [];
        controls.forEach((control, n) => {
          const parsed = parseInt(control.dataset.optionIndex, 10);
          const idx = Number.isNaN(parsed) ? n : parsed;
          const fits = (value) => variantsJson.some((v) => orderable(v) && v.options[idx] === value
            && chosen.every(([j, chosenValue]) => v.options[j] === chosenValue));
          if (control.tagName === 'SELECT') {
            let first = null;
            Array.from(control.options).forEach((option) => {
              const ok = fits(option.value);
              option.disabled = !ok;
              option.hidden = !ok;
              if (ok && first === null) first = option.value;
            });
            if (!fits(control.value) && first !== null) control.value = first;
          } else if (isChoice(control)) {
            /* TD Draft 2026-10-04 ADDON-UI — colour dots / text chips: same rule, the value's whole item is hidden */
            let first = null;
            radiosOf(control).forEach((radio) => {
              const ok = fits(radio.value);
              radio.disabled = !ok;
              const item = radio.closest('[data-td-choice-item]');
              if (item) item.hidden = !ok;
              if (ok && first === null) first = radio;
            });
            const checked = radiosOf(control).find((radio) => radio.checked);
            if ((!checked || checked.disabled) && first) first.checked = true;
            const current = control.querySelector('[data-td-choice-current]');
            if (current) current.textContent = valueOf(control);
          }
          chosen.push([idx, valueOf(control)]);
        });
        return chosen;
      };

      const resolveVariant = () => {
        if (!variantInput || !controls.length) return;
        const chosen = chosenOptions();
        const match = variantsJson.find((v) => orderable(v) && chosen.every(([j, chosenValue]) => v.options[j] === chosenValue));
        if (!match || String(match.id) === variantInput.value) return;
        variantInput.value = match.id;
        /* TD 2026-10-07 ADDON-QTY — the new variant's limit (a variant that stays at 1 hides the stepper), then its price
           for the chosen quantity */
        if (qtyInput) setQty(container, qtyInput.value, match);
        syncOpen();
        paintPrice(match);
        /* TD Draft 2026-10-04 ADDON-MASK — the thumbnail shows the chosen colour (mask) when the variant has an image */
        const thumb = container.querySelector('.td-upsell-addon__thumb img');
        if (thumb && match.image) {
          thumb.removeAttribute('srcset');
          thumb.removeAttribute('sizes');
          thumb.src = match.image;
        }
      };

      controls.forEach((control) => control.addEventListener('change', resolveVariant));
      resolveVariant();
    };

    const setupAll = () => document.querySelectorAll('[data-td-upsell-addon]').forEach((container) => {
      /* TD Draft 2026-10-04 ADDON-UI — a re-rendered block of an add-on that failed earlier stays hidden */
      if (!container.hidden && goneKeys.has(goneKey(container))) hideAddon(container);
      setupContainer(container);
    });
    setupAll();

    if (window.tdUpsellAddonListeners) return;
    window.tdUpsellAddonListeners = true;

    /* product change re-renders replace the whole product info: set up the new block after the swap */
    document.addEventListener('product:rerender', () => window.setTimeout(setupAll, 0), true);


    const formIdOf = (target) => (target && typeof target.getAttribute === 'function' ? target.getAttribute('id') || '' : '');

    /* TD Draft 2026-10-04 ADDON-MASK — every add-on block of this form, in page order (pillow, mask / vest) */
    const containersFor = (formId) => (formId
      ? Array.from(document.querySelectorAll('[data-td-upsell-addon]')).filter((el) => el.dataset.tdUpsellFormId === formId)
      : []);

    /* TD 2026-10-13 SECOND15 — hidden line properties of an add-on (data-td-upsell-properties, JSON object), e.g. the
       second mask / collar's {"_td_second":"1"} (snippets/td-addon-switch.liquid, mode 'same'): that unit becomes its own
       cart line and never merges with the main unit or an existing line of the same variant. Only keys starting with "_"
       (hidden in the cart and at checkout) and plain values are taken; add-ons without the attribute: null, as before. */
    const propertiesOf = (container) => {
      const raw = container && container.dataset ? container.dataset.tdUpsellProperties : '';
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        const out = {};
        Object.keys(parsed || {}).forEach((key) => {
          const value = parsed[key];
          if (/^_[A-Za-z0-9_]+$/.test(key) && (typeof value === 'string' || typeof value === 'number')) out[key] = String(value);
        });
        return Object.keys(out).length ? out : null;
      } catch (error) {
        return null;
      }
    };

    /* the switched-on add-on of one block: { id, quantity, container, properties } or null */
    const chosenUpsellOf = (container) => {
      if (isGone(container)) return null; /* TD Draft 2026-10-04 ADDON-UI — hidden after a failed add */
      const toggle = container.querySelector('[data-td-upsell-toggle]');
      const variantInput = container.querySelector('[data-td-upsell-variant-id]');
      if (!toggle || !toggle.checked || !variantInput) return null;
      const id = parseInt(variantInput.value, 10);
      if (!id) return null;
      const variant = readVariants(container).find((v) => String(v.id) === String(id));
      if (variant && !orderable(variant)) return null;
      /* TD 2026-10-07 ADDON-QTY — the stepper's value, kept within 1 … its max and the chosen variant's limit */
      const quantity = Math.min(qtyOf(container), qtyLimitOf(container, variant || null));
      return { id, quantity, container, properties: propertiesOf(container) };
    };

    /* every switched-on add-on of this form, in page order */
    const chosenUpsellsFor = (formId) => containersFor(formId).map(chosenUpsellOf).filter(Boolean);

    const HAS_FORMDATA_EVENT = typeof window.FormDataEvent === 'function';

    /* per form id, oldest first: { phase: 'armed' (submitted, request not built yet) | 'bundled' (add-ons in the request), … } */
    const queues = new Map();
    const queueOf = (formId) => {
      const now = Date.now();
      const list = (queues.get(formId) || []).filter((entry) => now - entry.at < 60000);
      queues.set(formId, list);
      return list;
    };
    const dropEntry = (formId, entry) => {
      const list = queueOf(formId);
      const index = list.indexOf(entry);
      if (index > -1) list.splice(index, 1);
    };
    /* the entry a theme answer (variant:add / cart:error) belongs to: the oldest request that was built */
    const answeredEntry = (formId) => {
      const list = queueOf(formId);
      return list.find((entry) => entry.phase === 'bundled') || (HAS_FORMDATA_EVENT ? null : list[0] || null);
    };

    /* a submit that does not become a request: theme.js ProductForm ignores a submitter that is still aria-busy,
       Q13 (assets/td-draft-0928-q13.js) stops submits while its busy label shows */
    const ignoredSubmit = (form, submitter) => {
      if (submitter && submitter.getAttribute('aria-busy') === 'true') return true;
      return Array.from(form.elements || []).some((el) => el.type === 'submit' && el.classList.contains('td-q13-busy'));
    };

    /* TD Draft 2026-10-04 ADDON-MASK — the main product's id/quantity/properties move to items[n][…], the add-ons go
       before it (reverse page order: Shopify puts the last line of a request on top, so the drawer reads main
       product, pillow, mask). Returns the main product's variant id. */
    const bundleInto = (data, upsells) => {
      const moved = [];
      Array.from(data.entries()).forEach(([key, value]) => {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.indexOf('properties[') === 0) moved.push([key, value]);
      });
      Array.from(new Set(moved.map(([key]) => key))).forEach((key) => data.delete(key));
      const ordered = upsells.slice().reverse();
      ordered.forEach((upsell, index) => {
        data.append(`items[${index}][id]`, String(upsell.id));
        data.append(`items[${index}][quantity]`, String(upsell.quantity));
        /* TD 2026-10-13 SECOND15 — the add-on's own hidden properties (second unit: _td_second) */
        Object.keys(upsell.properties || {}).forEach((key) => data.append(`items[${index}][properties][${key}]`, upsell.properties[key]));
      });
      const main = ordered.length;
      moved.forEach(([key, value]) => {
        data.append(key.indexOf('properties[') === 0 ? `items[${main}][properties]` + key.slice('properties'.length) : `items[${main}][${key}]`, value);
      });
      if (!data.has(`items[${main}][quantity]`)) data.append(`items[${main}][quantity]`, '1');
      return String(data.get(`items[${main}][id]`) || '');
    };

    /* TD 2026-10-07 ADDON-QTY — pieces of one add: the main product's submitted quantity + every add-on's quantity */
    const unitsOf = (mainEntries, upsells) => {
      const mainQty = (Array.isArray(mainEntries) ? mainEntries : []).reduce((n, [key, value]) => (key === 'quantity' ? (parseInt(value, 10) || 1) : n), 1);
      return mainQty + (upsells || []).reduce((n, upsell) => n + (upsell && upsell.quantity > 0 ? upsell.quantity : 1), 0);
    };

    /* main product first in the 'Hinzugefügt' row, then the add-ons in page order */
    const orderAddedItems = (items, mainId, upsellIds) => {
      if (!Array.isArray(items) || !mainId) return;
      const rank = (item) => {
        const id = String(item.variant_id || item.id);
        if (id === String(mainId)) return -1;
        const index = (upsellIds || []).map(String).indexOf(id);
        return index > -1 ? index : 999;
      };
      const sorted = items.map((item, index) => [item, index]).sort((a, b) => (rank(a[0]) - rank(b[0])) || (a[1] - b[1])).map(([item]) => item);
      items.splice(0, items.length, ...sorted);
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      const formId = formIdOf(form);
      if (!formId || !(form instanceof HTMLFormElement) || ignoredSubmit(form, event.submitter)) return;
      const upsells = chosenUpsellsFor(formId);
      if (!upsells.length) return;
      const entry = { phase: 'armed', upsellIds: upsells.map((upsell) => upsell.id), at: Date.now() };
      queueOf(formId).push(entry);
      if (HAS_FORMDATA_EVENT) {
        /* theme.js builds its request (new FormData → 'formdata') synchronously in its submit listener; an entry that is
           still 'armed' after this submit's dispatch built no request */
        window.setTimeout(() => {
          if (entry.phase === 'armed') dropEntry(formId, entry);
        }, 0);
      }
    }, true);

    document.addEventListener('formdata', (event) => {
      const formId = formIdOf(event.target);
      if (!formId) return;
      const entry = queueOf(formId).find((item) => item.phase === 'armed');
      if (!entry) return;
      const upsells = chosenUpsellsFor(formId);
      const data = event.formData;
      if (!upsells.length || !data || !data.get('id')) {
        dropEntry(formId, entry);
        return;
      }
      /* TD Draft 2026-10-05 FIX-0510 (Codex round 3, P1): the main product exactly as submitted (variant, quantity,
         properties, selling plan) — a retry after a failed add sends this, never what the form holds by then (the buyer
         may have picked another blanket while the request was on its way) */
      entry.mainEntries = Array.from(data.entries());
      entry.mainId = bundleInto(data, upsells);
      entry.phase = 'bundled';
      entry.upsells = upsells;
      entry.upsellIds = upsells.map((upsell) => upsell.id);
    }, true);

    /* TD Draft 2026-10-04 ADDON-MASK — is this add-on variant still orderable? true / false, null = unknown */
    const stillOrderable = async (upsell) => {
      const handle = upsell.container && upsell.container.dataset.tdUpsellHandle;
      if (!handle) return null;
      try {
        const response = await fetch(`${routeRoot()}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (response.status === 404) return false; /* TD Draft 2026-10-04 ADDON-UI — product unpublished / deleted */
        if (!response.ok) return null;
        const product = await response.json();
        const variant = (product.variants || []).find((v) => String(v.id) === String(upsell.id));
        return !!(variant && variant.available);
      } catch (error) {
        return null;
      }
    };

    /* TD Draft 2026-10-05 FIX-0510 (Codex round 3, P1) — what a /cart/add.js request did: 'ok' = answer with the added
       lines; 'rejected' = Shopify answered with an error (4xx with its JSON description, e.g. 422 "bereits ausverkauft"):
       nothing of the request is in the cart (checked 05.10.2026: a sold-out add-on with a blanket adds neither);
       'unknown' = no answer, an unreadable one or a server error: the lines may or may not be in the cart, so nothing is
       sent again without looking at the cart first */
    const outcomeOf = (response, json) => {
      if (response && response.ok && json) return 'ok';
      if (response && response.status >= 400 && response.status < 500 && json) return 'rejected';
      return 'unknown';
    };

    const readCart = async () => {
      try {
        const response = await fetch(`${routeRoot()}cart.js`, { headers: { Accept: 'application/json' } });
        return response.ok ? await response.json() : null;
      } catch (error) {
        return null;
      }
    };

    /* how many of a variant the cart holds, over all its lines */
    const quantityOf = (cart, variantId) => ((cart && cart.items) || []).reduce((sum, item) => (
      String(item.variant_id || item.id) === String(variantId) ? sum + (Number(item.quantity) || 0) : sum
    ), 0);

    /* one /cart/add.js request with the main product and the given add-ons. FIX-0510: the main product comes from the
       entries captured when the theme built the first request (mainEntries), not from the form as it is now; only
       without them (never expected) from the form */
    const addRequest = async (form, upsells, sections, mainEntries) => {
      let data;
      if (Array.isArray(mainEntries) && mainEntries.length) {
        data = new FormData(); /* no form: no 'formdata' event */
        mainEntries.forEach(([key, value]) => data.append(key, value));
      } else {
        data = new FormData(form); /* no 'armed' entry for this one: the formdata listener leaves it alone */
      }
      const mainId = upsells.length ? bundleInto(data, upsells) : String(data.get('id') || '');
      data.set('sections', sections.join(','));
      data.set('sections_url', `${routeRoot()}variants/${mainId}`);
      let response = null;
      let json = null;
      try {
        response = await fetch(`${routeRoot()}cart/add.js`, { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        json = await response.json().catch(() => null);
      } catch (error) {
        response = null;
      }
      const state = outcomeOf(response, json);
      return { ok: state === 'ok', state, json, data, mainId };
    };

    /* the add failed as a whole (Shopify adds all lines or none): add the main product with the add-ons that are still
       orderable, or alone; switch off only the add-ons that did not go in.
       FIX-0510 (Codex round 3, P1): every retry sends the main product as it was submitted (mainEntries). The main
       product alone is only tried after a definite 'rejected'; after an 'unknown' outcome nothing is sent again — the
       cart decides: more of the main variant than when the recovery started = that request went through (with its
       add-ons); otherwise, or when the cart cannot be read, the theme's error shows and the buyer can try again. */
    const addWithoutUpsell = async (form, formId, originalDetail, failed, mainEntries) => {
      const submitButtons = Array.from(form.elements).filter((el) => el.type === 'submit');
      submitButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

      const tried = (failed && failed.length) ? failed : [];
      /* the cart after the failed request (a rejected request added nothing): the baseline for an 'unknown' outcome */
      const baseline = await readCart();
      let keep = [];
      if (tried.length > 1) {
        const checks = await Promise.all(tried.map(stillOrderable));
        keep = tried.filter((upsell, index) => checks[index] === true);
        if (keep.length === tried.length) keep = []; /* every add-on looks orderable: the culprit is unknown */
      }
      let result = keep.length ? await addRequest(form, keep, sections, mainEntries) : null;
      if (!result || result.state === 'rejected') {
        keep = [];
        result = await addRequest(form, [], sections, mainEntries);
      }

      let through = false;
      if (result.state === 'unknown') {
        const after = await readCart();
        through = !!(baseline && after && quantityOf(after, result.mainId) > quantityOf(baseline, result.mainId));
      }

      submitButtons.forEach((button) => button.removeAttribute('aria-busy'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      if (through) {
        /* the request went through although its answer got lost: the add-ons it did not carry are hidden, the drawer
           shows the cart as it is */
        tried.filter((upsell) => !keep.includes(upsell)).forEach(({ container }) => {
          if (container && container.isConnected) hideAddon(container);
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      const { json, data } = result;
      if (result.ok) {
        /* TD Draft 2026-10-04 ADDON-UI — no note: every add-on that did not go in is switched off and hidden */
        const dropped = tried.length ? tried.filter((upsell) => !keep.includes(upsell)) : containersFor(formId).map((container) => ({ container }));
        dropped.forEach(({ container }) => {
          if (container && container.isConnected) hideAddon(container);
        });
        let cart = null;
        try {
          cart = await (await fetch(`${routeRoot()}cart.js`, { headers: { Accept: 'application/json' } })).json();
        } catch (error) {
          cart = null;
        }
        if (cart) {
          cart.sections = json.sections;
          const items = Object.prototype.hasOwnProperty.call(json, 'items') ? json.items : [json];
          orderAddedItems(items, result.mainId, keep.map((upsell) => upsell.id));
          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items, cart, onSuccessDo: data.get('on_success'), tdUpsellRetry: true, tdUnits: unitsOf(mainEntries, keep) }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: data.get('on_success'), cart }
          }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        return;
      }
      form.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: (json && json.description) || (originalDetail && originalDetail.error) || '', tdUpsellRetry: true }
      }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    };

    document.addEventListener('cart:error', (event) => {
      if (event.detail && event.detail.tdUpsellRetry) return;
      const form = event.target;
      const formId = formIdOf(form);
      if (!formId) return;
      const entry = answeredEntry(formId);
      if (!entry) return;
      dropEntry(formId, entry);
      if (entry.phase !== 'bundled' || !(form instanceof HTMLFormElement)) return;
      /* TD Draft 2026-10-05 FIX-0510B (Codex round 3c, P1): only a definite rejection of the first request starts the
         recovery — HTTP 4xx (theme.js now passes the status in detail.status; Shopify answers 422 for a sold-out line and
         adds nothing). A 5xx or a missing status may have added the lines: nothing is sent again, the theme shows its
         error and refreshes the drawer as usual (the cart shows what really went in). */
      const status = Number(event.detail && event.detail.status);
      if (!(status >= 400 && status < 500)) return;
      /* nobody else sees this error: the theme's banner, Q13's box and the 'Ausverkauft' text wait for the retry */
      event.stopImmediatePropagation();
      addWithoutUpsell(form, formId, event.detail, entry.upsells, entry.mainEntries);
    }, true);

    document.addEventListener('variant:add', async (event) => {
      if (event.detail && event.detail.tdUpsellRetry) return;
      const formId = formIdOf(event.target);
      if (!formId) return;
      const entry = answeredEntry(formId);
      if (!entry) return;
      dropEntry(formId, entry);
      const items = Array.isArray(event.detail?.items) ? event.detail.items : null;
      const has = (id) => !!items && items.some((item) => String(item.variant_id || item.id) === String(id));
      /* TD 2026-10-13 SECOND15 — an add-on with its own hidden properties is only "already in the answer" when a line of
         that variant carries the same properties (the second unit has the same variant as the main product) */
      const hasUpsell = (upsell) => (upsell.properties
        ? !!items && items.some((item) => String(item.variant_id || item.id) === String(upsell.id)
          && Object.keys(upsell.properties).every((key) => String((item.properties || {})[key]) === upsell.properties[key]))
        : has(upsell.id));

      if (entry.phase === 'bundled') {
        /* main product first in the 'Hinzugefügt' row (the add-ons went first in the request), add-ons in page order */
        if (items && entry.mainId) orderAddedItems(items, entry.mainId, entry.upsellIds);
        /* TD 2026-10-07 ADDON-QTY — 'Hinzugefügt · N Artikel' counts pieces (blanket + every add-on unit), not lines */
        if (event.detail && typeof event.detail === 'object') event.detail.tdUnits = unitsOf(entry.mainEntries, entry.upsells);
        return;
      }

      /* fallback (browser without the formdata event): second request after the theme's own add, with every
         switched-on add-on that is not in the cart answer yet */
      const upsells = chosenUpsellsFor(formId).filter((upsell) => !hasUpsell(upsell));
      if (!upsells.length) return;
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const postAddons = async (list) => {
        /* SECOND15 — the add-on's own hidden properties go along (second unit: _td_second) */
        const body = { items: list.slice().reverse().map(({ id, quantity, properties }) => (properties ? { id, quantity, properties } : { id, quantity })) };
        if (sections.length) {
          body.sections = sections.join(',');
          body.sections_url = window.location.pathname;
        }
        let response = null;
        let json = null;
        try {
          response = await fetch(routeRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          json = await response.json().catch(() => null);
        } catch (error) {
          response = null;
        }
        return { state: outcomeOf(response, json), json };
      };
      try {
        let added = upsells;
        let answer = await postAddons(upsells);
        /* FIX-0510 (Codex round 3): a second request only after a definite rejection; after an 'unknown' outcome the
           drawer shows the cart as it is (catch below) */
        if (answer.state === 'rejected') {
          /* TD Draft 2026-10-04 ADDON-UI — the add-ons that are still orderable go in again, the others are hidden */
          const checks = upsells.length > 1 ? await Promise.all(upsells.map(stillOrderable)) : [];
          added = upsells.filter((upsell, index) => checks[index] === true);
          if (added.length === upsells.length) added = [];
          answer = added.length ? await postAddons(added) : { state: 'rejected', json: null };
          if (answer.state === 'rejected') added = [];
          if (answer.state !== 'unknown') upsells.filter((upsell) => !added.includes(upsell)).forEach(({ container }) => hideAddon(container));
        }
        if (answer.state !== 'ok') throw new Error('upsell add failed');
        const json = answer.json;
        const cart = await (await fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        const rendered = json && json.sections;
        if (cart && rendered && sections.length && sections.every((id) => typeof rendered[id] === 'string' && rendered[id])) {
          cart.sections = rendered;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'td-upsell:add', cart } }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) {
        /* the main product is in the cart; the drawer shows the cart as it is */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }, true);
  };

  /* -----------------------------------------------
     TD Draft 2026-10-04 ADDON-SLIDER — <td-addon-slider> (snippets/td-addon-slider.liquid, styles in assets/custom.css).
     Felix 04.10.2026: "Maybe slider for more than 1 upsell" — two or more add-on switches (pillow, mask / vest) side by
     side, one card at a time, the next one peeking in.
     - Scrolling is the browser's own (swipe, trackpad, scroll-snap); this code only follows it: the dot of the card in
       view is current, the arrows are disabled at the ends, and the cards out of view are inert (no Tab stop, no
       screen-reader content, no accidental switch). A tap on a peeking card brings it into view.
     - Dots, arrows and the arrow keys on a dot scroll to a card (smooth; instant with "reduce motion"); the focus stays
       on the dot / arrow, and Shift+Tab from there leads into the card in view.
     - Switched-on cards: their dot and the card itself get data-td-as-on (dot filled in the switch colour, label
       "… (hinzugefügt)", card with the chosen border). Switching a card on or off never scrolls the slider.
     - A card whose add-on is hidden at runtime (initTdUpsellAddon hideAddon: could not go into the cart) leaves the
       slider: slide labels and dots are rebuilt; with fewer than two cards the slider falls back to the single-box
       layout (class td-addon-slider--single, no region / group roles, no dots, nothing inert).
     - The switches, their options and the add-to-cart logic (initTdUpsellAddon) are untouched: a switched-on card stays
       in the cart request while it is out of view.
     ----------------------------------------------- */
  const initTdAddonSlider = () => {
    if (!window.customElements || window.customElements.get('td-addon-slider')) return;

    const reduceMotion = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    const fill = (template, index, count) => String(template || '').replace(/__I__/g, String(index)).replace(/__N__/g, String(count));
    const setAttr = (el, name, value) => {
      if (value === null || value === undefined) {
        if (el.hasAttribute(name)) el.removeAttribute(name);
      } else if (el.getAttribute(name) !== String(value)) {
        el.setAttribute(name, String(value));
      }
    };

    class TdAddonSlider extends HTMLElement {
      connectedCallback() {
        if (this.tdAbort) return;
        this.track = this.querySelector('[data-td-as-track]');
        if (!this.track) return;
        this.dotsBox = this.querySelector('[data-td-as-dots]');
        this.prevButton = this.querySelector('[data-td-as-prev]');
        this.nextButton = this.querySelector('[data-td-as-next]');
        if (!this.tdRegion) {
          this.tdRegion = {
            role: this.getAttribute('role'),
            roledescription: this.getAttribute('aria-roledescription'),
            label: this.getAttribute('aria-label')
          };
        }
        this.current = this.current || 0;
        this.single = false;
        this.lock = null;
        this.tdAbort = new AbortController();
        const signal = this.tdAbort.signal;

        const onScroll = () => {
          if (this.frame) return;
          this.frame = window.requestAnimationFrame(() => {
            this.frame = 0;
            this.follow();
          });
        };
        this.track.addEventListener('scroll', onScroll, { passive: true, signal });
        window.addEventListener('resize', onScroll, { passive: true, signal });
        this.track.addEventListener('scrollend', () => {
          this.lock = null;
          this.follow();
        }, { signal });
        /* the user takes over: a running dot / arrow scroll no longer holds the current dot */
        ['pointerdown', 'touchstart', 'wheel'].forEach((type) => this.track.addEventListener(type, () => {
          this.lock = null;
        }, { passive: true, signal }));

        /* a switch was turned on / off: mark its dot and card (no scrolling) */
        this.track.addEventListener('change', (event) => {
          if (event.target && event.target.matches && event.target.matches('[data-td-upsell-toggle]')) this.paint();
        }, { signal });

        /* a tap on a peeking card brings it into view (inert cards get no events of their own, so the track gets the
           click); a click on a control of a card out of view (browsers without inert) is left to the focus below */
        this.track.addEventListener('click', (event) => {
          if (this.single) return;
          const index = this.slides().findIndex((slide) => {
            const r = slide.getBoundingClientRect();
            return event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
          });
          if (index < 0 || index === this.current) return;
          const target = event.target && event.target.closest ? event.target.closest('label, input, button, a, select, textarea') : null;
          if (target && this.track.contains(target)) return;
          this.goTo(index);
        }, { signal });

        /* focus inside a card out of view (only possible without inert) brings that card into view */
        this.track.addEventListener('focusin', (event) => {
          if (this.single) return;
          const index = this.slides().findIndex((slide) => slide.contains(event.target));
          if (index > -1 && index !== this.current) this.goTo(index);
        }, { signal });

        /* ArrowLeft / ArrowRight on a switch: to the neighbouring card's switch (otherwise the browser scrolls the track
           by itself and the focus ends up on a dot); the colour dots / chips keep their own arrow keys */
        this.track.addEventListener('keydown', (event) => {
          if (this.single || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (!event.target || !event.target.matches || !event.target.matches('[data-td-upsell-toggle]')) return;
          event.preventDefault();
          const slides = this.slides();
          const from = slides.findIndex((slide) => slide.contains(event.target));
          const to = from + (event.key === 'ArrowRight' ? 1 : -1);
          if (from < 0 || to < 0 || to >= slides.length) return;
          const toggle = slides[to].querySelector('[data-td-upsell-toggle]');
          slides[to].inert = false;
          if (toggle) toggle.focus({ preventScroll: true });
          this.goTo(to);
        }, { signal });

        if (this.dotsBox) {
          this.dotsBox.addEventListener('click', (event) => {
            const dot = event.target && event.target.closest ? event.target.closest('button') : null;
            const index = this.dots().indexOf(dot);
            if (index > -1) this.goTo(index);
          }, { signal });
          this.dotsBox.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            const dots = this.dots();
            const from = dots.indexOf(document.activeElement);
            if (from < 0) return;
            event.preventDefault();
            const to = Math.max(0, Math.min(dots.length - 1, from + (event.key === 'ArrowRight' ? 1 : -1)));
            this.goTo(to);
            dots[to].focus();
          }, { signal });
        }
        if (this.prevButton) this.prevButton.addEventListener('click', () => this.goTo(this.current - 1), { signal });
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.goTo(this.current + 1), { signal });

        /* theme editor: a selected add-on block comes into view */
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides().findIndex((slide) => slide.contains(event.target));
          if (index > -1) this.goTo(index, true);
        }, { signal });
        /* back / forward cache: the switches may come back switched on */
        window.addEventListener('pageshow', () => this.paint(), { signal });

        /* an add-on hidden at runtime (hideAddon sets hidden on its block item) */
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.track, { subtree: true, attributes: true, attributeFilter: ['hidden'] });

        this.sync();
      }

      disconnectedCallback() {
        if (this.tdAbort) this.tdAbort.abort();
        this.tdAbort = null;
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      allSlides() {
        return Array.from(this.track.children).filter((el) => el.hasAttribute('data-td-as-slide'));
      }

      slides() {
        return this.allSlides().filter((slide) => !slide.hidden);
      }

      dots() {
        return this.dotsBox ? Array.from(this.dotsBox.children) : [];
      }

      /* scroll position of every card in view, as scroll-snap places it (start, the last ones at the end) */
      positions() {
        const track = this.track;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const origin = track.getBoundingClientRect().left - track.scrollLeft;
        return this.slides().map((slide) => Math.max(0, Math.min(max, Math.round(slide.getBoundingClientRect().left - origin))));
      }

      /* which cards take part, single-box fallback, roles, labels and one dot per card */
      sync() {
        this.allSlides().forEach((slide) => {
          const item = slide.querySelector('.product-info__block-item');
          const addon = slide.querySelector('[data-td-upsell-addon]');
          const gone = !item || item.hidden || !addon || addon.hidden;
          if (slide.hidden !== gone) slide.hidden = gone;
          if (gone) {
            slide.inert = false;
            setAttr(slide, 'data-td-as-on', null);
          }
        });
        const slides = this.slides();
        const count = slides.length;
        this.single = count < 2;
        if (this.hidden !== (count === 0)) this.hidden = count === 0;
        this.classList.toggle('td-addon-slider--single', this.single);
        setAttr(this, 'role', this.single ? null : this.tdRegion.role);
        setAttr(this, 'aria-roledescription', this.single ? null : this.tdRegion.roledescription);
        setAttr(this, 'aria-label', this.single ? null : this.tdRegion.label);
        slides.forEach((slide, index) => {
          setAttr(slide, 'role', this.single ? null : 'group');
          setAttr(slide, 'aria-roledescription', this.single ? null : (this.dataset.tplSlide || null));
          setAttr(slide, 'aria-label', this.single ? null : fill(this.dataset.tplPosition, index + 1, count));
        });
        if (this.dotsBox && this.dots().length !== count) {
          this.dotsBox.textContent = '';
          for (let i = 0; i < count; i += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-controls', this.track.id);
            dot.setAttribute('aria-current', 'false');
            this.dotsBox.append(dot);
          }
        }
        this.current = Math.max(0, Math.min(this.current, count - 1));
        this.lock = null;
        this.follow(true);
        this.paint();
      }

      /* the card in view follows the scroll position (the nearest snap position) */
      follow(force) {
        if (this.single) return;
        const pos = this.positions();
        if (!pos.length) return;
        const x = this.track.scrollLeft;
        let index = 0;
        pos.forEach((p, i) => {
          if (Math.abs(x - p) < Math.abs(x - pos[index])) index = i;
        });
        if (this.lock) {
          if (index !== this.lock.index && performance.now() < this.lock.until) return;
          this.lock = null;
        }
        if (index !== this.current || force) {
          this.current = index;
          if (!force) this.paint();
        }
      }

      goTo(index, instant) {
        if (this.single) return;
        const pos = this.positions();
        if (!pos.length) return;
        const to = Math.max(0, Math.min(pos.length - 1, index));
        this.lock = { index: to, until: performance.now() + 900 };
        this.track.scrollTo({ left: pos[to], behavior: instant || reduceMotion() ? 'auto' : 'smooth' });
        this.current = to;
        this.paint();
      }

      /* current dot, switched-on marks, labels, arrow ends, inert cards out of view */
      paint() {
        const slides = this.slides();
        const count = slides.length;
        const dots = this.dots();
        const on = slides.map((slide) => {
          const toggle = slide.querySelector('[data-td-upsell-toggle]');
          return !!(toggle && toggle.checked) && !this.single;
        });
        slides.forEach((slide, index) => {
          setAttr(slide, 'data-td-as-on', on[index] ? '' : null);
          const away = !this.single && index !== this.current;
          if (!!slide.inert !== away) {
            /* the focus never stays behind in a card that leaves the view: it goes to the current dot */
            if (away && slide.contains(document.activeElement) && dots[this.current]) dots[this.current].focus({ preventScroll: true });
            slide.inert = away;
          }
        });
        dots.forEach((dot, index) => {
          setAttr(dot, 'aria-current', index === this.current ? 'true' : 'false');
          setAttr(dot, 'data-td-as-on', on[index] ? '' : null);
          setAttr(dot, 'aria-label', fill(on[index] ? this.dataset.tplGoToOn : this.dataset.tplGoTo, index + 1, count));
        });
        if (this.prevButton) setAttr(this.prevButton, 'aria-disabled', this.current <= 0 ? 'true' : 'false');
        if (this.nextButton) setAttr(this.nextButton, 'aria-disabled', this.current >= count - 1 ? 'true' : 'false');
      }
    }

    window.customElements.define('td-addon-slider', TdAddonSlider);
  };

  const initCertificatesDots = () => {
    document.querySelectorAll('.td-certificates-dots').forEach((dotsContainer) => {
      const scrollId = dotsContainer.dataset.scrollTarget;
      const scroll = document.getElementById(scrollId);
      if (!scroll) return;

      const dots = dotsContainer.querySelectorAll('.td-certificates-dot');
      if (!dots.length) return;

      const itemsPerPage = 2;
      const getItems = () => scroll.querySelectorAll('.td-certificates-logos__item');

      const updateDots = () => {
        const items = getItems();
        if (!items.length) return;
        const itemWidth = items[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(scroll).columnGap) || 0;
        const pageWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;
        const currentPage = Math.round(scroll.scrollLeft / pageWidth);
        dots.forEach((dot) => {
          dot.classList.toggle('is-active', parseInt(dot.dataset.page) === currentPage);
        });
      };

      scroll.addEventListener('scroll', updateDots, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const page = parseInt(dot.dataset.page);
          const items = getItems();
          if (!items.length) return;
          const itemWidth = items[0].offsetWidth;
          const gap = parseFloat(getComputedStyle(scroll).columnGap) || 0;
          const pageWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;
          scroll.scrollTo({ left: page * pageWidth, behavior: 'smooth' });
        });
      });

      updateDots();
    });
  };

  const initTdImageWithTemperatureScale = () => {
    const roots = document.querySelectorAll('[data-td-temperature-scale]');
    if (!roots.length) return;

    const readImageMap = (root) => {
      const script = root.querySelector('script[data-td-temperature-scale-images]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent || '{}');
      } catch (error) {
        return {};
      }
    };

    const applyImage = (image, data) => {
      if (!image) return;

      if (data?.src) {
        image.src = data.src;
        image.dataset.tdTemperatureScaleCurrent = data.src;
      } else if (image.dataset.tdTemperatureScaleFallbackSrc) {
        image.src = image.dataset.tdTemperatureScaleFallbackSrc;
        image.dataset.tdTemperatureScaleCurrent = image.dataset.tdTemperatureScaleFallbackSrc;
      }

      if (data?.srcset) {
        image.srcset = data.srcset;
      } else if (image.dataset.tdTemperatureScaleFallbackSrcset) {
        image.srcset = image.dataset.tdTemperatureScaleFallbackSrcset;
      } else {
        image.removeAttribute('srcset');
      }

      if (data?.alt != null) {
        image.alt = data.alt;
      } else if (image.dataset.tdTemperatureScaleFallbackAlt != null) {
        image.alt = image.dataset.tdTemperatureScaleFallbackAlt;
      }
    };

    const readGalleryImage = (imageIndex) => {
      const gallery = document.querySelector('product-gallery');
      if (!gallery) return null;

      const images = Array.from(
        gallery.querySelectorAll('.product-gallery__media:not([hidden]) img')
      ).filter((galleryImage) => galleryImage.currentSrc || galleryImage.src);

      const galleryImage = images[imageIndex];
      if (!galleryImage) return null;

      return {
        src: galleryImage.currentSrc || galleryImage.src,
        srcset: galleryImage.getAttribute('srcset') || '',
        alt: galleryImage.getAttribute('alt') || ''
      };
    };

    const hydrateRoot = (root) => {
      const image = root.querySelector('[data-td-temperature-scale-image]');
      if (!image) return null;

      image.dataset.tdTemperatureScaleFallbackSrc = image.currentSrc || image.src || '';
      image.dataset.tdTemperatureScaleFallbackSrcset = image.getAttribute('srcset') || '';
      image.dataset.tdTemperatureScaleFallbackAlt = image.getAttribute('alt') || '';

      return {
        image,
        useGalleryImage: root.dataset.tdTemperatureScaleUseGalleryImage === 'true',
        galleryImageIndex: Math.max(
          0,
          parseInt(root.dataset.tdTemperatureScaleGalleryImageIndex || '1', 10) || 1
        ),
        imageMap: readImageMap(root)
      };
    };

    const instances = Array.from(roots).map(hydrateRoot).filter(Boolean);
    if (!instances.length) return;

    const refreshFromGallery = () => {
      instances.forEach(({ image, useGalleryImage, galleryImageIndex }) => {
        if (useGalleryImage) {
          const galleryImage = readGalleryImage(galleryImageIndex);
          if (galleryImage) {
            applyImage(image, galleryImage);
          }
        }
      });
    };

    refreshFromGallery();

    document.addEventListener('product:rerender', () => {
      requestAnimationFrame(refreshFromGallery);
    });

    document.addEventListener('variant:change', (event) => {
      const variantId = event.detail?.variant?.id;
      if (!variantId) return;

      requestAnimationFrame(() => {
        instances.forEach(({ image, useGalleryImage, galleryImageIndex, imageMap }) => {
          const galleryImage = readGalleryImage(galleryImageIndex);
          if (useGalleryImage && galleryImage) {
            applyImage(image, galleryImage);
          } else {
            applyImage(image, imageMap[String(variantId)]);
          }
        });
      });
    });
  };

  /* TD Draft 2026-09-26 D07 — Weight helper: recommends only offered + available weights from the variant
     metafield custom.weight; the fixed 4/6/8/10/12 kg table is only the fallback. Delegated handlers, so
     the helper keeps working after Prestige re-renders the picker. The open x-modal is moved to <body>,
     so the picker is found through data-form-id instead of closest(). */
  const initTdWeightHelper = () => {
    if (window.tdWeightHelperBound) return;
    window.tdWeightHelperBound = true;
    const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const parseRange = (text) => {
      if (!text) return null;
      /* metafield may carry an icon span and a trailing sentence ('Bis 90 kg +. Die Gewichtsempfehlung …') */
      const t = String(text).replace(/<[^>]*>/g, '').split(':').pop().split('.')[0].replace(/–/g, '-');
      let m = t.match(/(\d+)\s*-\s*(\d+)/);
      if (m) return [Number(m[1]), Number(m[2])];
      m = t.match(/(\d+)\s*kg\s*\+/i) || t.match(/ab\s*(\d+)/i);
      if (m) return [Number(m[1]), Infinity];
      m = t.match(/bis\s*(\d+)/i);
      if (m) return [30, Number(m[1])]; /* TD Draft 2026-10-01 GATE — open 'Bis N' = adult range: same 30 kg floor as the adults table on live */
      /* TD 2026-10-01 INTL-PDP — translated texts ('Up to 69 kg', 'Jusqu'à 69 kg', 'Fino a 69 kg', 'Tot 69 kg', '110 kg et plus',
         '31 à 40 kg'): language-independent fallback as in snippets/td-pdpf-range.liquid — two numbers = range, one number with
         '+' or a 'from' word = open end, any other single number = 'up to' (30 kg floor as above). German always matches above. */
      const n = t.replace(/[\u00a0\u202f]/g, ' ').match(/\d+/g);
      if (n && n.length >= 2 && Number(n[1]) > Number(n[0])) return [Number(n[0]), Number(n[1])];
      if (n && n.length) {
        if (/\+|(^|[^a-z\u00c0-\u024f])(ab|über|from|over|above|more|plus|partir|dès|desde|más|mas|da|oltre|più|piu|vanaf|meer|boven)([^a-z\u00c0-\u024f]|$)/i.test(t)) return [Number(n[0]), Infinity];
        if (Number(n[0]) > 0) return [30, Number(n[0])];
      }
      return null;
    };
    const readData = (helper) => {
      const s = helper && helper.querySelector('script[data-td-weight-data]');
      if (!s) return null;
      try { return JSON.parse(s.textContent); } catch (e) { return null; }
    };
    const findPicker = (helper) => {
      if (!helper) return null;
      const inside = helper.closest('[data-td-variant-picker]');
      if (inside) return inside;
      const formId = helper.dataset.formId;
      return formId ? document.querySelector(`[data-td-variant-picker][data-form-id="${escapeValue(formId)}"]`) : null;
    };
    /* TD Draft 2026-09-30 D07-FIX — fallback table only for products without custom.weight ranges. 'offered' (optional):
       the available weights of this product per size ({'135 x 200 cm': [6, 8], '': [3, 4]}); the table value is then
       replaced by the heaviest offered weight that is not heavier than the table value (never a heavier blanket), and
       'no match' when even the lightest offered weight is heavier (audit 30.09.: kids 45 kg → '5 kg', only 3 and 4 kg exist). */
    const fitOffered = (kg, list) => {
      if (!list || !list.length) return kg;
      const ok = list.filter((x) => x <= kg);
      return ok.length ? Math.max(...ok) : null;
    };
    const legacyHtml = (helper, w, offered) => {
      const head = `<p class="td-weight-helper__result-heading bold">${esc(helper.dataset.resultHeading || '')}</p>`;
      const noMatch = `<p class="td-weight-helper__error">${esc(helper.dataset.noMatch || '')}</p>`;
      const sizes = offered ? Object.keys(offered) : [];
      /* a product that only offers children's sizes (90/100/110 x …) uses the kids table, whatever the block preset says
         (audit 30.09.: kids cotton blankets had the adults preset and refused 25 kg) */
      const kidsOnly = sizes.length > 0 && sizes.every((sz) => /^(90|100|110)\s*x\s*\d/.test(sz));
      if ((helper.dataset.type || 'adults') === 'adults' && !kidsOnly) {
        if (w < 30) return `<p class="td-weight-helper__error">${esc(helper.dataset.errorAdults || '')}</p>`;
        const [s, l] = w <= 49 ? [4, 6] : w <= 69 ? [6, 8] : w <= 89 ? [8, 10] : w <= 109 ? [10, 12] : [12, 12];
        if (!offered) return `${head}<ul class="td-weight-helper__result-list"><li>135 × 200 cm: <strong>${s} kg</strong></li><li>150 × 220 cm: <strong>${l} kg</strong></li></ul>`;
        let items = '';
        sizes.forEach((size) => {
          const want = /150\s*x\s*220/.test(size) ? l : s;
          const kg = fitOffered(want, offered[size]);
          if (kg != null) items += `<li>${size ? esc(size.replace(/ x /g, ' × ')) + ': ' : ''}<strong>${kg} kg</strong></li>`;
        });
        return items ? `${head}<ul class="td-weight-helper__result-list">${items}</ul>` : noMatch;
      }
      if (w < 5 || w > 70) return `<p class="td-weight-helper__error">${esc(helper.dataset.errorKids || '')}</p>`;
      const k = w <= 10 ? 1 : w <= 20 ? 2 : w <= 30 ? 3 : w <= 40 ? 4 : w <= 50 ? 5 : w <= 60 ? 6 : 7;
      if (!offered) return `${head}<p class="td-weight-helper__result-value"><strong>${k} kg</strong></p>`;
      let items = '';
      sizes.forEach((size) => {
        const kg = fitOffered(k, offered[size]);
        if (kg != null) items += `<li>${size ? esc(size.replace(/ x /g, ' × ')) + ': ' : ''}<strong>${kg} kg</strong></li>`;
      });
      return items ? `${head}<ul class="td-weight-helper__result-list">${items}</ul>` : noMatch;
    };
    const calculate = (helper) => {
      if (!helper) return;
      const input = helper.querySelector('.td-weight-helper__input');
      const result = helper.querySelector('.td-weight-helper__result');
      if (!input || !result) return;
      const bw = parseFloat(String(input.value).replace(',', '.'));
      if (Number.isNaN(bw) || bw <= 0) { result.hidden = true; return; }
      const data = readData(helper);
      const wPos = String(data && data.weightPos);
      const sPos = String((data && data.sizePos) || 0);
      const all = (data && data.variants) || [];
      /* body-weight range depends on size + blanket weight only: variants without the metafield
         (e.g. kids Reißverschluss / Medizinisch) borrow it from a sibling with the same size + weight */
      const known = {};
      all.forEach((v) => { const r = parseRange(v.w); if (r) known[`${v['o' + sPos]}|${v['o' + wPos]}`] = r; });
      const variants = all
        .map((v) => Object.assign({}, v, { range: parseRange(v.w) || known[`${v['o' + sPos]}|${v['o' + wPos]}`] || null }))
        .filter((v) => v.range);
      if (!variants.length) {
        /* TD Draft 2026-09-30 D07-FIX — no ranges at all: fall back to the table, limited to the weights this product
           offers (available, same other options as selected; per size). Not for a capped JSON (≥ 250 variants). */
        let offered = null;
        if (all.length && all.length < 250 && wPos && wPos !== 'undefined') {
          const pickerNR = findPicker(helper);
          const selNR = {};
          if (pickerNR) pickerNR.querySelectorAll('input[data-option-position]:checked').forEach((el) => { selNR[el.dataset.optionPosition] = el.dataset.optionValue; });
          offered = {};
          all.forEach((v) => {
            if (!v.a) return;
            for (const p of ['1', '2', '3']) {
              if (p === wPos || p === sPos) continue;
              if (v['o' + p] != null && selNR[p] != null && v['o' + p] !== selNR[p]) return;
            }
            const kg = parseFloat(String(v['o' + wPos] || '').replace(',', '.'));
            if (Number.isNaN(kg)) return;
            const size = sPos !== '0' ? String(v['o' + sPos] || '') : '';
            (offered[size] = offered[size] || []).includes(kg) || offered[size].push(kg);
          });
          if (!Object.keys(offered).length) offered = null;
        }
        result.innerHTML = legacyHtml(helper, bw, offered);
        result.hidden = false;
        return;
      }
      const bwr = Math.round(bw); /* ranges are whole kilos ('50 - 69', '70 - 89') */
      /* TD Draft 2026-10-01 GATE — below the lightest class: never recommend a blanket (live refused under 30 kg for adults) */
      const tdFloor = Math.min(...variants.map((v) => v.range[0]));
      /* TD 2026-10-04 FIX-0410 — unrounded value for the lower limit (29,9 kg was rounded to 30 and got a recommendation) */
      if (bw < tdFloor) { result.innerHTML = `<p class="td-weight-helper__error">${esc((tdFloor >= 30 ? helper.dataset.errorAdults : helper.dataset.noMatch) || '')}</p>`; result.hidden = false; return; }
      const picker = findPicker(helper);
      const selected = {};
      if (picker) picker.querySelectorAll('input[data-option-position]:checked').forEach((el) => { selected[el.dataset.optionPosition] = el.dataset.optionValue; });
      const pick = (filterOthers) => {
        const found = new Map();
        variants.forEach((v) => {
          if (!v.a || bwr < v.range[0] || bwr > v.range[1]) return;
          if (filterOthers) {
            for (const p of ['1', '2', '3']) {
              if (p === wPos || p === sPos) continue;
              if (v['o' + p] != null && selected[p] != null && v['o' + p] !== selected[p]) return;
            }
          }
          const size = sPos !== '0' ? v['o' + sPos] : '';
          const cur = found.get(size);
          if (!cur || v.range[1] < cur.range[1]) found.set(size, v);
        });
        return found;
      };
      let best = pick(true);
      /* Liquid product.variants stops at 250 (set-gravity: 400 combinations) → the selected covers may be
         missing from the JSON; then use the ranges of the other versions instead of claiming 'nothing available' */
      if (!best.size && all.length >= 250) best = pick(false);
      /* still nothing with a capped JSON (set-gravity: the 12 kg rows are beyond variant 250) → fall back to the
         live table instead of claiming 'nothing available' */
      if (!best.size && all.length >= 250) { result.innerHTML = legacyHtml(helper, bw); result.hidden = false; return; }
      if (!best.size) {
        result.innerHTML = `<p class="td-weight-helper__error">${esc(helper.dataset.noMatch || '')}</p>`;
        result.hidden = false;
        return;
      }
      let items = '';
      let applyWeight = null;
      best.forEach((v, size) => {
        const w = v['o' + wPos];
        items += `<li>${size ? esc(String(size).replace(/ x /g, ' × ')) + ': ' : ''}<strong>${esc(w)}</strong></li>`;
        if (sPos === '0' || size === selected[sPos]) applyWeight = w;
      });
      let html = `<p class="td-weight-helper__result-heading bold">${esc(helper.dataset.resultHeading || '')}</p><ul class="td-weight-helper__result-list">${items}</ul>`;
      if (picker && applyWeight && applyWeight !== selected[wPos]) {
        html += `<button type="button" class="td-weight-helper__apply button" data-weight="${esc(applyWeight)}">${esc((helper.dataset.selectLabel || '%w%').replace('%w%', applyWeight))}</button>`;
      }
      result.innerHTML = html;
      result.hidden = false;
    };
    const apply = (btn) => {
      const helper = btn.closest('.td-weight-helper');
      const data = readData(helper);
      const picker = findPicker(helper);
      if (!data || !picker) return;
      const target = [...picker.querySelectorAll(`input[data-option-position="${data.weightPos}"]`)].find((el) => el.dataset.optionValue === btn.dataset.weight);
      const modal = btn.closest('x-modal');
      if (modal && typeof modal.hide === 'function') modal.hide();
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    document.addEventListener('click', (event) => {
      const typeBtn = event.target.closest('.td-weight-helper__type-btn');
      if (typeBtn) {
        const h = typeBtn.closest('.td-weight-helper');
        if (!h) return;
        h.querySelectorAll('.td-weight-helper__type-btn').forEach((b) => b.classList.toggle('is-active', b === typeBtn));
        h.dataset.type = typeBtn.dataset.type;
        const r = h.querySelector('.td-weight-helper__result');
        if (r) r.hidden = true;
        return;
      }
      const calcBtn = event.target.closest('.td-weight-helper__calc-btn');
      if (calcBtn) { calculate(calcBtn.closest('.td-weight-helper')); return; }
      const applyBtn = event.target.closest('.td-weight-helper__apply');
      if (applyBtn) apply(applyBtn);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !event.target.matches || !event.target.matches('.td-weight-helper__input')) return;
      event.preventDefault();
      calculate(event.target.closest('.td-weight-helper'));
    });
  };

  /* TD Draft 2026-09-27 Q23 — accordion steps for the TD variant picker (block setting accordion_steps, product page
     only). Markup and first-paint state: snippets/td-variant-picker.liquid + snippets/td-linked-option.liquid.
     - One step open per section. A selection by the buyer closes its step and opens the next one (auto-advance);
       the last step stays open. Single-choice groups (at most one value the buyer can pick) are static summary rows
       and are skipped; see isStatic for the availability source (same information as the Liquid first paint).
     - The next step is decided only after Prestige has swapped in the block rendered for the NEW selection and the
       sold-out filter has run on it (product:rerender microtask, before paint): a change records an advance request
       (changed step + value + focus intent) and never a destination computed from the previous selection. With a
       preloaded response that is still the task of the click; otherwise the step stays open until the response lands.
     - Prestige swaps the picker block on every variant change, so the open step is kept per section id and
       re-applied in that microtask (before the next paint, like the D02 handler).
     - Only changes by the buyer advance: the sold-out filter's auto-selection dispatches an untrusted change.
       The weight helper's 'X kg auswählen' counts as a completed weight step.
     - Keyboard: arrow keys change the value inside the open group (it stays open to compare); Enter/Space on the
       chosen value confirms it and moves focus to the next step header. Pointer changes never move focus, except
       out of a step that closes (focus would otherwise be lost in the hidden body). A closing body is inert at once,
       so nothing in it can take focus or clicks during the 0.2s animation.
     - html.td-acc-off: the inline fallback in the snippets gave up waiting for this file (window load); a late
       custom.js turns the accordion back on. */
  const initTdAccordionSteps = () => {
    if (window.tdAccBound) return;
    window.tdAccBound = true;
    document.documentElement.classList.remove('td-acc-off');
    document.documentElement.classList.add('td-acc-ready', 'td-acc-js'); /* also after a late load, when the inline fallback had expanded every step */
    if (!document.querySelector('[data-td-acc-step]') && !window.Shopify?.designMode) return;

    const DURATION = 200;
    const FALLBACK_MS = 5000; /* no re-render for the new selection (request failed): decide with the client-side state */
    const reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    const openBySection = new Map(); /* section id → key of the open step; null = the buyer closed every step */
    const lastAnim = new Map(); /* section id → { from: key open before the animated change, t } */
    const pending = new Map(); /* section id → advance request waiting for the re-render of the new selection */
    const unsettled = new Map(); /* section id → last option change whose re-render has not landed yet */
    let lastInput = { type: '', time: 0 };
    let helperApplyAt = 0;
    let kbdConfirmInput = null;
    let advancedTo = { key: '', t: 0 }; /* step just opened by auto-advance (it slides in under the pointer) */

    const recent = (type) => lastInput.type === type && Date.now() - lastInput.time < 1500;
    const inSection = (sectionId, key) => `[data-td-acc-step][data-td-acc-section="${escapeValue(sectionId)}"]${key ? `[data-td-acc-key="${escapeValue(key)}"]` : ''}`;
    const stepsOf = (sectionId) => [...document.querySelectorAll(inSection(sectionId))];
    const headerOf = (step) => step && step.querySelector(':scope > .td-acc__header');
    const bodyOf = (step) => step && step.querySelector(':scope > .td-acc__body');
    const checkedValue = (step) => {
      const input = step && step.querySelector('input[data-option-position]:checked');
      return input ? input.dataset.optionValue || '' : null;
    };

    /* single-choice step = at most one value the buyer can pick, from the same information as the Liquid first paint:
       a value hidden by hide_sold_out_variants (disabled input / hidden link) never counts, the checked value always
       counts; otherwise the sold-out filter's visibility decides (same cascade as option_value.available, and it knows
       its own client-side auto-selection). When the availability JSON is capped (product.variants stops at 250 →
       data-td-acc-partial), the server's per-value flag data-td-acc-ok (option_value.available) decides instead, so a
       value the filter hid for lack of data never turns a real choice into a static row. */
    const isStatic = (step) => {
      if (step.hasAttribute('data-td-acc-linked')) return step.classList.contains('td-acc__step--static');
      const partial = !!step.closest('[data-td-acc-partial]');
      let selectable = 0;
      step.querySelectorAll('[data-option-val]').forEach((wrapper) => {
        if (wrapper.hidden) return;
        const control = wrapper.querySelector('input[data-option-position], a[href]');
        if (control && (control.disabled || control.hidden)) return;
        if (control && control.checked) { selectable += 1; return; }
        if (partial && wrapper.dataset.tdAccOk) { if (wrapper.dataset.tdAccOk === 'true') selectable += 1; return; }
        if (wrapper.style.display !== 'none') selectable += 1;
      });
      return selectable <= 1;
    };

    /* header/summary value = checked input; weight steps also show the card's body-weight range (D07, when present) */
    const syncValue = (step) => {
      if (step.hasAttribute('data-td-acc-linked')) return;
      const input = step.querySelector('input[data-option-position]:checked');
      if (!input) return;
      const value = input.dataset.optionValue || '';
      step.querySelectorAll('[data-td-acc-value], [data-td-acc-summary-value]').forEach((el) => {
        if (el.textContent !== value) el.textContent = value;
      });
      const rangeEl = step.querySelector('[data-td-acc-range]');
      if (rangeEl) {
        const wrapper = input.closest('[data-option-val]');
        const range = wrapper ? wrapper.querySelector('.td-variant-picker__weight-range') : null;
        const text = range ? range.textContent.trim() : '';
        rangeEl.textContent = text;
        rangeEl.hidden = !text;
      }
    };

    const setStep = (step, open, animate) => {
      const stat = isStatic(step);
      const header = headerOf(step);
      const summary = step.querySelector(':scope > .td-acc__summary');
      const body = bodyOf(step);
      step.classList.toggle('td-acc__step--static', stat);
      if (header) header.hidden = stat;
      if (summary) summary.hidden = !stat;
      const shouldOpen = open && !stat;
      if (header) header.setAttribute('aria-expanded', String(shouldOpen));
      if (body) {
        /* closing: focus leaves the body first (to its header), then the body is inert right away — it stays visible
           for the animation, but nothing in it can be tabbed to, clicked or read out */
        if (!shouldOpen && body.contains(document.activeElement) && header && !header.hidden) header.focus({ preventScroll: true });
        body.inert = !shouldOpen;
      }
      if (step.classList.contains('is-open') === shouldOpen) return;
      clearTimeout(step.tdAccTimer);
      if (animate && !reduceMotion.matches) {
        step.classList.remove('td-acc--instant');
        step.classList.add('td-acc--animating');
        step.tdAccTimer = setTimeout(() => step.classList.remove('td-acc--animating'), DURATION + 60);
      } else {
        step.classList.remove('td-acc--animating');
        step.classList.add('td-acc--instant');
        requestAnimationFrame(() => requestAnimationFrame(() => step.classList.remove('td-acc--instant')));
      }
      step.classList.toggle('is-open', shouldOpen);
    };

    const firstOpenable = (steps, from, direction) => {
      for (let i = from; i >= 0 && i < steps.length; i += direction) {
        if (!isStatic(steps[i])) return steps[i];
      }
      return null;
    };

    /* key → step that should be open now (the stored step may have become single-choice after a re-render) */
    const resolveOpen = (steps, key) => {
      if (key === null) return null;
      const index = Math.max(0, steps.findIndex((s) => s.dataset.tdAccKey === key));
      return firstOpenable(steps, index, 1) || firstOpenable(steps, index - 1, -1);
    };

    const apply = (sectionId, animate) => {
      const steps = stepsOf(sectionId);
      if (!steps.length) return;
      steps.forEach(syncValue);
      const stored = openBySection.get(sectionId);
      const open = resolveOpen(steps, stored === undefined ? '' : stored);
      if (stored !== null) openBySection.set(sectionId, open ? open.dataset.tdAccKey : '');
      steps.forEach((step) => setStep(step, step === open, animate));
    };

    const sectionIds = () => new Set([...document.querySelectorAll('[data-td-acc-step]')].map((s) => s.dataset.tdAccSection));
    const applyAll = () => sectionIds().forEach((id) => apply(id, false));

    /* animate from what the buyer saw (fromKey open) to the stored state; the start state is set without transition
       and flushed, so it is never painted on its own — the swapped-in block arrives in the server's first-paint state */
    const transition = (sectionId, fromKey, replay) => {
      if (reduceMotion.matches) { apply(sectionId, false); return; }
      const steps = stepsOf(sectionId);
      steps.forEach((step) => setStep(step, step.dataset.tdAccKey === fromKey, false));
      if (steps[0]) steps[0].getBoundingClientRect(); /* style flush */
      if (!replay) lastAnim.set(sectionId, { from: fromKey, t: Date.now() });
      apply(sectionId, true);
    };

    /* header click: animate from the current state (see the product:rerender handler for a swap during the animation) */
    const applyAnimated = (sectionId) => {
      const before = document.querySelector(`${inSection(sectionId)}.is-open`);
      lastAnim.set(sectionId, { from: before ? before.dataset.tdAccKey : null, t: Date.now() });
      apply(sectionId, true);
    };

    /* after a swap without an advance request for it: re-apply the stored step before the next paint; if the swap
       landed while a step was still animating (cached/preloaded response), replay that animation from its start state */
    const applyAfterRerender = (sectionId) => {
      const anim = lastAnim.get(sectionId);
      if (anim && Date.now() - anim.t < DURATION && !reduceMotion.matches) transition(sectionId, anim.from, true);
      else apply(sectionId, false);
    };

    /* after a user-opened step has expanded: scroll just enough to show it (below the sticky header / bar) */
    const reveal = (step) => {
      const run = () => {
        if (!step.isConnected) {
          step = document.querySelector(inSection(step.dataset.tdAccSection, step.dataset.tdAccKey));
          if (!step) return;
        }
        const header = headerOf(step) || step;
        const top = header.getBoundingClientRect().top;
        const offset = parseFloat(getComputedStyle(header).scrollMarginTop) || 0;
        let bottomLimit = window.innerHeight - 12;
        const bar = document.querySelector('.product-sticky-bar');
        if (bar) {
          const r = bar.getBoundingClientRect();
          if (r.height && r.top < window.innerHeight && getComputedStyle(bar).visibility !== 'hidden') bottomLimit = Math.min(bottomLimit, r.top - 12);
        }
        const bottom = step.getBoundingClientRect().bottom;
        let delta = 0;
        if (top < offset) delta = top - offset;
        else if (bottom > bottomLimit) delta = Math.min(bottom - bottomLimit, top - offset);
        if (Math.abs(delta) > 4) window.scrollBy({ top: delta, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      if (reduceMotion.matches) requestAnimationFrame(run);
      else setTimeout(run, DURATION + 40);
    };

    /* the weight helper's modal returns focus to its trigger, which the re-render replaced: hand it on */
    const handOffAfterHelper = (sectionId, key, advanced) => setTimeout(() => {
      const a = document.activeElement;
      if (a && a !== document.body && a.isConnected && !a.closest('.td-acc__body[inert]')) return;
      const current = document.querySelector(inSection(sectionId, key));
      if (!current) return;
      const target = advanced ? headerOf(current) : (current.querySelector('input[data-option-position]:checked') || headerOf(current));
      if (target && !target.hidden) target.focus({ preventScroll: true });
    }, 700);

    const cancelAdvance = (sectionId) => {
      const request = pending.get(sectionId);
      if (request) clearTimeout(request.timer);
      pending.delete(sectionId);
    };

    /* decide the auto-advance on the block that shows the new selection (availability applied), then animate */
    const resolveAdvance = (sectionId) => {
      const request = pending.get(sectionId);
      if (!request) return;
      cancelAdvance(sectionId);
      const steps = stepsOf(sectionId);
      const step = steps.find((s) => s.dataset.tdAccKey === request.key);
      if (!step) { apply(sectionId, false); return; }
      steps.forEach(syncValue);
      const next = firstOpenable(steps, steps.indexOf(step) + 1, 1);
      openBySection.set(sectionId, (next || step).dataset.tdAccKey);
      transition(sectionId, request.from);
      if (next) {
        advancedTo = { key: `${sectionId}|${next.dataset.tdAccKey}`, t: Date.now() };
        if (request.focus) headerOf(next).focus({ preventScroll: true });
        reveal(next);
      }
      if (request.helper) handOffAfterHelper(sectionId, (next || step).dataset.tdAccKey, !!next);
    };

    /* a buyer's selection (or keyboard confirm): record what changed, not where to go */
    const requestAdvance = (step, { focus = false, helper = false } = {}) => {
      const sectionId = step.dataset.tdAccSection;
      cancelAdvance(sectionId);
      const open = document.querySelector(`${inSection(sectionId)}.is-open`);
      const request = { key: step.dataset.tdAccKey, value: checkedValue(step), combo: comboOf(sectionId, step.dataset.tdAccKey), el: step, from: open ? open.dataset.tdAccKey : null, focus, helper, timer: 0 };
      pending.set(sectionId, request);
      if (!unsettled.has(sectionId)) { resolveAdvance(sectionId); return; } /* the block on screen already shows this selection */
      request.timer = setTimeout(() => {
        if (pending.get(sectionId) !== request) return;
        unsettled.delete(sectionId);
        resolveAdvance(sectionId);
      }, FALLBACK_MS);
    };

    /* a re-render answers `entry` when its step is a new node that shows the chosen value (a late response for an
       earlier selection shows another value; the sold-out filter's own check on the old node is no re-render) */
    const answers = (steps, entry) => {
      const step = steps.find((s) => s.dataset.tdAccKey === entry.key);
      if (!step || step === entry.el || checkedValue(step) !== entry.value) return false;
      /* the whole selection up to that step must match: a late response for an earlier upstream choice shows other values */
      return (entry.combo || []).every(([key, value]) => {
        const s = steps.find((x) => x.dataset.tdAccKey === key);
        return !s || s.hasAttribute('data-td-acc-linked') || checkedValue(s) === value;
      });
    };
    /* checked values of every step from the first one up to (and including) `key` */
    const comboOf = (sectionId, key) => {
      const combo = [];
      for (const s of stepsOf(sectionId)) {
        if (!s.hasAttribute('data-td-acc-linked')) combo.push([s.dataset.tdAccKey, checkedValue(s)]);
        if (s.dataset.tdAccKey === key) break;
      }
      return combo;
    };

    /* focus that sat in a step: Prestige re-focuses the element with the same id after the swap, which fails when the
       new block still has that step closed. Put it back (open step) or on that step's header (closed step). */
    const restoreFocus = (focusedId) => {
      const a = document.activeElement;
      if (!focusedId || (a && a !== document.body)) return;
      const el = document.getElementById(focusedId);
      const step = el && el.closest('[data-td-acc-step]');
      if (!step) return;
      if (step.classList.contains('is-open') || el === headerOf(step)) el.focus({ preventScroll: true });
      else if (headerOf(step) && !headerOf(step).hidden) headerOf(step).focus({ preventScroll: true });
    };

    document.addEventListener('pointerdown', () => { lastInput = { type: 'pointer', time: Date.now() }; }, true);

    document.addEventListener('keydown', (event) => {
      const key = event.key;
      if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight') {
        lastInput = { type: 'arrow', time: Date.now() };
        return;
      }
      if (key !== ' ' && key !== 'Enter' && key !== 'Spacebar') {
        lastInput = { type: 'key', time: Date.now() };
        return;
      }
      lastInput = { type: 'confirm', time: Date.now() };
      const input = event.target;
      if (!input || !input.matches || !input.matches('input[type="radio"][data-option-position]')) return;
      const step = input.closest('[data-td-acc-step].is-open');
      if (!step) return;
      if (key === 'Enter') event.preventDefault(); /* no implicit submit (add to cart) from an option value */
      if (input.checked) {
        event.preventDefault();
        requestAdvance(step, { focus: true });
      } else if (key === 'Enter' && !input.disabled) {
        kbdConfirmInput = input;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (!event.target.closest) return;
      /* a double tap / double click on a value must not also pick a card in, or toggle the header of, the step that just slid under the pointer */
      const hit = event.detail > 0 && Date.now() - advancedTo.t < 400 && event.target.closest('[data-td-acc-step] > .td-acc__body, [data-td-acc-step] > .td-acc__header');
      if (hit) {
        const step = hit.parentElement;
        if (`${step.dataset.tdAccSection}|${step.dataset.tdAccKey}` === advancedTo.key) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }
      if (event.target.closest('.td-weight-helper__apply')) {
        helperApplyAt = Date.now();
        return;
      }
      const link = event.target.closest('[data-td-acc-linked] a[href]');
      if (link) {
        /* a linked value loads another product: open the step after it there */
        const step = link.closest('[data-td-acc-step]');
        try {
          sessionStorage.setItem('tdAccAdvance', JSON.stringify({ key: step.dataset.tdAccKey, kbd: event.detail === 0, t: Date.now() }));
        } catch (e) { /* storage blocked: the new page opens its first step */ }
      }
    }, true);

    document.addEventListener('click', (event) => {
      const header = event.target.closest ? event.target.closest('.td-acc__header') : null;
      const step = header ? header.closest('[data-td-acc-step]') : null;
      if (!step) return;
      const wasOpen = step.classList.contains('is-open');
      cancelAdvance(step.dataset.tdAccSection); /* the buyer's own choice wins over a pending auto-advance */
      openBySection.set(step.dataset.tdAccSection, wasOpen ? null : step.dataset.tdAccKey);
      applyAnimated(step.dataset.tdAccSection);
      if (!wasOpen) reveal(step);
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input || !input.matches || !input.matches('input[data-option-position]')) return;
      const step = input.closest('[data-td-acc-step]');
      if (!step) return;
      const sectionId = step.dataset.tdAccSection;
      unsettled.set(sectionId, { key: step.dataset.tdAccKey, value: input.dataset.optionValue || '', combo: comboOf(sectionId, step.dataset.tdAccKey), el: step });
      syncValue(step);
      const fromHelper = Date.now() - helperApplyAt < 1000;
      const fromKbdConfirm = kbdConfirmInput === input;
      kbdConfirmInput = null;
      if (!event.isTrusted && !fromHelper && !fromKbdConfirm) return; /* auto-selection (sold-out filter, re-select); an open request stays */
      if (!fromHelper && !fromKbdConfirm && recent('arrow')) { cancelAdvance(sectionId); return; } /* arrow keys browse the values: stay open */
      requestAdvance(step, { focus: fromKbdConfirm || (!fromHelper && recent('confirm')), helper: fromHelper });
    }, true); /* capture: runs before Prestige's body listener, which can swap the block within the same dispatch */

    /* product:rerender fires on the form before <product-rerender> swaps the block; the microtask runs after the swap and
       after variant:change (the sold-out filter has hidden / auto-selected values on the new block), before paint.
       The filter may still run again in the next frames (rAF listeners in initTdVariantPicker): re-apply once more. */
    document.addEventListener('product:rerender', (event) => {
      if (event.target && event.target.closest && event.target.closest('quick-buy-modal')) return;
      const active = document.activeElement;
      const focusedId = active && active.id && active.closest && active.closest('[data-td-acc-step]') ? active.id : '';
      queueMicrotask(() => {
        sectionIds().forEach((id) => {
          const steps = stepsOf(id);
          const change = unsettled.get(id);
          if (change && answers(steps, change)) unsettled.delete(id);
          const request = pending.get(id);
          /* resolve only on the block for the latest selection: while a newer change (incl. a sold-out auto-selection) is
             still unanswered, keep waiting (the request's timer is the fallback) */
          if (request && !unsettled.has(id) && answers(steps, request)) resolveAdvance(id);
          else applyAfterRerender(id);
        });
        restoreFocus(focusedId);
      });
      requestAnimationFrame(() => requestAnimationFrame(applyAll));
    }, true);

    document.addEventListener('shopify:section:load', (event) => {
      const id = event.detail && event.detail.sectionId;
      if (id) { openBySection.delete(id); cancelAdvance(id); unsettled.delete(id); }
      applyAll();
    });

    applyAll();

    let handoff = null;
    try {
      handoff = JSON.parse(sessionStorage.getItem('tdAccAdvance') || 'null');
      sessionStorage.removeItem('tdAccAdvance');
    } catch (e) { handoff = null; }
    if (handoff && handoff.key && Date.now() - handoff.t < 30000) {
      const from = document.querySelector(`[data-td-acc-step][data-td-acc-key="${escapeValue(handoff.key)}"]`);
      if (from) {
        const steps = stepsOf(from.dataset.tdAccSection);
        const next = firstOpenable(steps, steps.indexOf(from) + 1, 1);
        if (next) {
          openBySection.set(from.dataset.tdAccSection, next.dataset.tdAccKey);
          apply(from.dataset.tdAccSection, false);
          if (handoff.kbd) headerOf(next).focus({ preventScroll: true });
        }
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initDeliveryTime();
      initTdVariantPicker();
      initTdWeightHelper();
      initTdAccordionSteps();
      initTdCollectionProducts();
      initTdUpsellAddon();
      initTdAddonSlider();
      initTdImageWithTemperatureScale();
      initCertificatesDots();
    });
  } else {
    initDeliveryTime();
    initTdVariantPicker();
    initTdWeightHelper();
    initTdAccordionSteps();
    initTdCollectionProducts();
    initTdUpsellAddon();
    initTdAddonSlider();
    initTdImageWithTemperatureScale();
    initCertificatesDots();
  }
})();

/* TD Draft 2026-09-26 D01 — theme.js fills the countdown only on its first 1s tick,
   so '00 T 00 Std 00 Min' showed for 0.4–1s after the timer became visible.
   Paint the real remaining time as soon as the elements are defined. */
customElements.whenDefined('countdown-timer-flip').then(() => {
  document.querySelectorAll('countdown-timer[expires-at]').forEach((timer) => {
    let delta = (new Date(timer.getAttribute('expires-at')) - Date.now()) / 1000;
    if (!(delta > 0)) return;
    const parts = { days: Math.floor(delta / 86400) };
    delta -= parts.days * 86400;
    parts.hours = Math.floor(delta / 3600);
    delta -= parts.hours * 3600;
    parts.minutes = Math.floor(delta / 60);
    parts.seconds = Math.floor(delta - parts.minutes * 60);
    timer.querySelectorAll('countdown-timer-flip[type]').forEach((flip) => flip.updateValue?.(parts[flip.getAttribute('type')]));
  });
});

/* TD Draft 2026-10-05 APP-TEST — Felix 05.10.2026 ("nothing gets the 10%"): until go-live the rules of the discount app
   SMART Functions Creator exist only as code discounts (test codes TDAPP…TEST), so a preview cart got no app discount at
   all. With codes in the cart drawer setting td_app_test_codes (sections/cart-drawer.liquid → [data-td-app-test-codes]),
   an UNPUBLISHED theme puts the missing ones into the cart once per page view and refreshes the drawer: /cart/update.js
   keeps the codes already there, and a code waits in the cart until its products are in it (checked 05.10.2026).
   The published theme (Shopify.theme.role 'main') never does, even with the setting filled; an empty setting does
   nothing. Go-live: empty the setting — the app rules then run automatically. */
(() => {
  const run = () => {
    const holder = document.querySelector('[data-td-app-test-codes]');
    const theme = window.Shopify && window.Shopify.theme;
    if (!holder || !theme || !theme.role || theme.role === 'main') return;
    const wanted = (holder.getAttribute('data-td-app-test-codes') || '').split(',').map((code) => code.trim()).filter(Boolean);
    if (!wanted.length) return;
    const root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (!cart) return null;
        const have = (cart.discount_codes || []).map((entry) => String((entry && entry.code) || '')).filter(Boolean);
        const upper = have.map((code) => code.toUpperCase());
        const missing = wanted.filter((code) => !upper.includes(code.toUpperCase()));
        if (!missing.length) return null;
        return fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: have.concat(missing).join(',') })
        }).then((response) => {
          if (response.ok) document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      })
      .catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
